// This file is auto-generated from the translation JSON file
// Do not edit manually
// Use npm run generate-t7e instead!
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-explicit-any */
import i18next from 'i18next';

export const Keys = [
  'countries.AAT',
  'countries.AB',
  'countries.ABS',
  'countries.AC',
  'countries.ADG',
  'countries.AF',
  'countries.AG',
  'countries.AGUK',
  'countries.ALG',
  'countries.ALL',
  'countries.AM',
  'countries.ANALSAT',
  'countries.ANTN',
  'countries.AO',
  'countries.AQ',
  'countries.AR',
  'countries.ARGN',
  'countries.ARV',
  'countries.ASRA',
  'countries.AT',
  'countries.AU',
  'countries.AUS',
  'countries.AZ',
  'countries.AZER',
  'countries.B',
  'countries.BASH',
  'countries.BAT',
  'countries.BB',
  'countries.BBUK',
  'countries.BD',
  'countries.BEL',
  'countries.BELA',
  'countries.BERM',
  'countries.BG',
  'countries.BGN',
  'countries.BH',
  'countries.BM',
  'countries.BO',
  'countries.BOL',
  'countries.BR',
  'countries.BRAZ',
  'countries.BS',
  'countries.BT',
  'countries.BW',
  'countries.BY',
  'countries.CA',
  'countries.CD',
  'countries.CH',
  'countries.CHBZ',
  'countries.CHLE',
  'countries.CI',
  'countries.CIS',
  'countries.CK',
  'countries.CL',
  'countries.CM',
  'countries.CN',
  'countries.CO',
  'countries.COL',
  'countries.COLP',
  'countries.CR',
  'countries.CSFR',
  'countries.CSSR',
  'countries.CU',
  'countries.CYM',
  'countries.CYMRU',
  'countries.CZ',
  'countries.CZCH',
  'countries.D',
  'countries.DAG',
  'countries.DD',
  'countries.DEN',
  'countries.DJ',
  'countries.DK',
  'countries.DML',
  'countries.DR',
  'countries.DX',
  'countries.DZ',
  'countries.E',
  'countries.EC',
  'countries.ECU',
  'countries.EE',
  'countries.EG',
  'countries.EGYP',
  'countries.ENG',
  'countries.ESA',
  'countries.ESA/JAXA',
  'countries.ESCN',
  'countries.ESIB',
  'countries.EST',
  'countries.ET',
  'countries.EUME',
  'countries.EUTE',
  'countries.F',
  'countries.FGER',
  'countries.FI',
  'countries.FIN',
  'countries.FR',
  'countries.FRIT',
  'countries.GE',
  'countries.GER',
  'countries.GH',
  'countries.GI',
  'countries.GL',
  'countries.GLOB',
  'countries.GR',
  'countries.GRD',
  'countries.GREC',
  'countries.GT',
  'countries.GU',
  'countries.GUF',
  'countries.HK',
  'countries.HKUK',
  'countries.HR',
  'countries.HU',
  'countries.HUN',
  'countries.I',
  'countries.I-ARAB',
  'countries.I-CSC1',
  'countries.I-ELDO',
  'countries.I-ESA',
  'countries.I-ESRO',
  'countries.I-EU',
  'countries.I-EUM',
  'countries.I-EUT',
  'countries.I-INM',
  'countries.I-INT',
  'countries.I-ISS',
  'countries.I-NATO',
  'countries.I-RASC',
  'countries.ID',
  'countries.IE',
  'countries.IL',
  'countries.IM',
  'countries.IN',
  'countries.IND',
  'countries.INDO',
  'countries.IQ',
  'countries.IR',
  'countries.IRAN',
  'countries.IRAQ',
  'countries.IS',
  'countries.ISRA',
  'countries.ISS',
  'countries.IT',
  'countries.ITSO',
  'countries.J',
  'countries.JO',
  'countries.JPN',
  'countries.KAZ',
  'countries.KE',
  'countries.KG',
  'countries.KGSR',
  'countries.KH',
  'countries.KI',
  'countries.KORS',
  'countries.KORSA',
  'countries.KP',
  'countries.KR',
  'countries.KW',
  'countries.KZ',
  'countries.L',
  'countries.LA',
  'countries.LAOS',
  'countries.LB',
  'countries.LK',
  'countries.LT',
  'countries.LTU',
  'countries.LUXE',
  'countries.LV',
  'countries.LY',
  'countries.MA',
  'countries.MALA',
  'countries.MC',
  'countries.MD',
  'countries.ME',
  'countries.MEX',
  'countries.MH',
  'countries.MN',
  'countries.MR',
  'countries.MU',
  'countries.MV',
  'countries.MX',
  'countries.MY',
  'countries.MYM',
  'countries.N',
  'countries.NATO',
  'countries.NETH',
  'countries.NG',
  'countries.NICO',
  'countries.NIG',
  'countries.NKOR',
  'countries.NL',
  'countries.NOR',
  'countries.NP',
  'countries.NZ',
  'countries.NZRD',
  'countries.O3B',
  'countries.OM',
  'countries.ORB',
  'countries.P',
  'countries.PAKI',
  'countries.PAR',
  'countries.PCZ',
  'countries.PE',
  'countries.PERU',
  'countries.PG',
  'countries.PH',
  'countries.PK',
  'countries.PL',
  'countries.PLRL',
  'countries.POL',
  'countries.POR',
  'countries.PR',
  'countries.PRC',
  'countries.PT',
  'countries.PY',
  'countries.QA',
  'countries.RASC',
  'countries.RO',
  'countries.ROC',
  'countries.ROM',
  'countries.RP',
  'countries.RU',
  'countries.RW',
  'countries.S',
  'countries.SA',
  'countries.SAFR',
  'countries.SAUD',
  'countries.SB',
  'countries.SCOT',
  'countries.SD',
  'countries.SEAL',
  'countries.SES',
  'countries.SG',
  'countries.SH',
  'countries.SI',
  'countries.SING',
  'countries.SK',
  'countries.SKOR',
  'countries.SN',
  'countries.SPN',
  'countries.SR',
  'countries.STCT',
  'countries.SU',
  'countries.SWED',
  'countries.SWTZ',
  'countries.SY',
  'countries.T',
  'countries.Taiwan',
  'countries.TBD',
  'countries.TC',
  'countries.TF',
  'countries.THAI',
  'countries.TJ',
  'countries.TM',
  'countries.TMMC',
  'countries.TN',
  'countries.TO',
  'countries.TR',
  'countries.TTPI',
  'countries.TURK',
  'countries.TUVA',
  'countries.TW',
  'countries.UA',
  'countries.UAE',
  'countries.UG',
  'countries.UK',
  'countries.UKR',
  'countries.UM',
  'countries.URY',
  'countries.US',
  'countries.USA',
  'countries.USBZ',
  'countries.UY',
  'countries.UZ',
  'countries.VE',
  'countries.VENZ',
  'countries.VN',
  'countries.VTNM',
  'countries.YE',
  'countries.ZA',
  'countries.ZR',
  'countries.ZW',
  'splashScreens.1',
  'splashScreens.2',
  'splashScreens.3',
  'splashScreens.4',
  'splashScreens.5',
  'splashScreens.6',
  'splashScreens.7',
  'splashScreens.8',
  'splashScreens.9',
  'splashScreens.10',
  'splashScreens.11',
  'splashScreens.12',
  'splashScreens.13',
  'splashScreens.14',
  'splashScreens.15',
  'splashScreens.16',
  'splashScreens.17',
  'splashScreens.18',
  'splashScreens.19',
  'splashScreens.20',
  'splashScreens.21',
  'splashScreens.22',
  'splashScreens.23',
  'splashScreens.24',
  'splashScreens.25',
  'splashScreens.26',
  'splashScreens.27',
  'splashScreens.28',
  'splashScreens.29',
  'loadingScreenMsgs.math',
  'loadingScreenMsgs.science',
  'loadingScreenMsgs.science2',
  'loadingScreenMsgs.dots',
  'loadingScreenMsgs.satIntel',
  'loadingScreenMsgs.painting',
  'loadingScreenMsgs.coloring',
  'loadingScreenMsgs.elsets',
  'loadingScreenMsgs.models',
  'loadingScreenMsgs.cunningPlan',
  'copyright.notice',
  'copyright.noticeMobile',
  'colorSchemes.CelestrakColorScheme.label',
  'colorSchemes.ConfidenceColorScheme.label',
  'colorSchemes.CountryColorScheme.label',
  'colorSchemes.GpAgeColorScheme.label',
  'colorSchemes.MissionColorScheme.label',
  'colorSchemes.ObjectTypeColorScheme.label',
  'colorSchemes.OrbitalPlaneDensityColorScheme.label',
  'colorSchemes.RcsColorScheme.label',
  'colorSchemes.ReentryRiskColorScheme.label',
  'colorSchemes.SmallSatColorScheme.label',
  'colorSchemes.SourceColorScheme.label',
  'colorSchemes.SpatialDensityColorScheme.label',
  'colorSchemes.StarlinkColorScheme.label',
  'colorSchemes.SunlightColorScheme.label',
  'colorSchemes.VelocityColorScheme.label',
  'colorSchemes.VisualMagnitudeColorScheme.label',
  'Common.orbitPreview',
  'Common.unknown',
  'help.overview',
  'help.howToUse',
  'help.tips',
  'help.keyboardShortcuts',
  'help.troubleshooting',
  'loadingScreen.startButton',
  'loadingScreen.hint',
  'loadingScreen.downloadingScience',
  'loadingScreen.loadFailed',
  'loadingScreen.resetAndReload',
  'loadingScreen.edition.pro',
  'loadingScreen.edition.oss',
  'loadingScreen.edition.celestrak',
  'loadingScreen.edition.embed',
  'loadingScreen.edition.offline',
  'loadingScreen.edition.epfl',
  'loadingScreen.edition.companion',
  'loadingScreen.edition.solar-system',
  'errorMsgs.LoginRequired',
  'errorMsgs.catalogNotFullyInitialized',
  'errorMsgs.sensorGroupsApiEmpty',
  'errorMsgs.SelectSensorFirst',
  'errorMsgs.SelectSatelliteFirst',
  'errorMsgs.SelectSecondarySatellite',
  'errorMsgs.SatelliteNotDetailedSatellite',
  'errorMsgs.SensorNotFound',
  'errorMsgs.Scene.disablingGodrays',
  'errorMsgs.Scene.disablingAurora',
  'errorMsgs.Scene.disablingAtmosphere',
  'errorMsgs.Scene.disablingMoon',
  'errorMsgs.Scene.disablingMilkyWay',
  'errorMsgs.Scene.disablingSun',
  'errorMsgs.Reports.popupBlocker',
  'errorMsgs.SensorManager.errorUpdatingUi',
  'hoverManager.launched',
  'hoverManager.launchedPlanned',
  'hoverManager.launchedUnknown',
  'darkClouds.in',
  'darkClouds.satellites',
  'darkClouds.and',
  'darkClouds.debris',
  'darkClouds.buildingBuffers',
  'darkClouds.presentDay',
  'plugins.proOnlyMsg',
  'plugins.WatchlistOverlay.bottomIconLabel',
  'plugins.WatchlistOverlay.title',
  'plugins.WatchlistOverlay.helpBody',
  'plugins.WatchlistOverlay.openOverlayCmd',
  'plugins.WatchlistOverlay.addSatellitesToast',
  'plugins.WatchlistOverlay.noPassesMsg',
  'plugins.WatchlistOverlay.inFovToast',
  'plugins.WatchlistOverlay.leftFovToast',
  'plugins.WatchlistOverlay.tiers.inView',
  'plugins.WatchlistOverlay.tiers.nextUp',
  'plugins.WatchlistOverlay.tiers.upcoming',
  'plugins.WatchlistOverlay.tiers.later',
  'plugins.WatchlistOverlay.tiers.background',
  'plugins.WatchlistOverlay.tiers.departed',
  'plugins.SensorFov.bottomIconLabel',
  'plugins.SensorSurvFence.bottomIconLabel',
  'plugins.SatelliteViewPlugin.bottomIconLabel',
  'plugins.NightToggle.bottomIconLabel',
  'plugins.Screenshot.bottomIconLabel',
  'plugins.Screenshot.rmbMenu.title',
  'plugins.Screenshot.commands.take4k',
  'plugins.Screenshot.commands.takeHd',
  'plugins.Screenshot.commands.take8k',
  'plugins.TimeMachine.bottomIconLabel',
  'plugins.TimeMachine.settings.disableToasts.label',
  'plugins.TimeMachine.settings.disableToasts.helpText',
  'plugins.ScreenRecorder.bottomIconLabel',
  'plugins.BestPassPlugin.sections.search',
  'plugins.BestPassPlugin.bottomIconLabel',
  'plugins.BestPassPlugin.title',
  'plugins.BestPassPlugin.satelliteNumbersLabel',
  'plugins.BestPassPlugin.generateButton',
  'plugins.BestPassPlugin.selectSensorFirst',
  'plugins.BestPassPlugin.errorMsgs.SensorRequired',
  'plugins.BestPassPlugin.errorMsgs.SensorFormatError',
  'plugins.BestPassPlugin.errorMsgs.ResultsTruncated',
  'plugins.BestPassPlugin.help.overview',
  'plugins.BestPassPlugin.help.imgAlt',
  'plugins.BestPassPlugin.help.imgCaption',
  'plugins.BestPassPlugin.help.howToUse',
  'plugins.BestPassPlugin.help.tip1',
  'plugins.BestPassPlugin.help.tip2',
  'plugins.BestPassPlugin.help.tip3',
  'plugins.BestPassPlugin.help.shortcutToggle',
  'plugins.Breakup.bottomIconLabel',
  'plugins.Breakup.title',
  'plugins.Breakup.sideMenuTitle',
  'plugins.Breakup.labels.satelliteScc',
  'plugins.Breakup.labels.initialSatelliteNumber',
  'plugins.Breakup.labels.pieces',
  'plugins.Breakup.labels.sourceSection',
  'plugins.Breakup.labels.catalogSlotsSection',
  'plugins.Breakup.labels.dispersionSection',
  'plugins.Breakup.labels.eventTypeLabel',
  'plugins.Breakup.labels.preset_explosion',
  'plugins.Breakup.labels.preset_collision',
  'plugins.Breakup.labels.preset_asat_cosmos',
  'plugins.Breakup.labels.preset_asat_fy1c',
  'plugins.Breakup.labels.preset_venting',
  'plugins.Breakup.labels.preset_custom',
  'plugins.Breakup.labels.radialDeltaV',
  'plugins.Breakup.labels.inTrackDeltaV',
  'plugins.Breakup.labels.crossTrackDeltaV',
  'plugins.Breakup.labels.dispersionHint',
  'plugins.Breakup.labels.piecesSection',
  'plugins.Breakup.buttons.createBreakup',
  'plugins.Breakup.buttons.clearBreakup',
  'plugins.Breakup.commands.create',
  'plugins.Breakup.commands.clear',
  'plugins.Breakup.toasts.cleared',
  'plugins.Breakup.toasts.fragmentsReentered',
  'plugins.Breakup.help.overview',
  'plugins.Breakup.help.imgAlt',
  'plugins.Breakup.help.imgCaption',
  'plugins.Breakup.help.parametersHeading',
  'plugins.Breakup.help.parameters',
  'plugins.Breakup.help.howToUse',
  'plugins.Breakup.help.tip1',
  'plugins.Breakup.help.tip2',
  'plugins.Breakup.help.tip3',
  'plugins.Breakup.errorMsgs.SatelliteNotFound',
  'plugins.Breakup.errorMsgs.ErrorCreatingBreakup',
  'plugins.Breakup.errorMsgs.InvalidStartNum',
  'plugins.Breakup.errorMsgs.InvalidSlotRange',
  'plugins.Breakup.errorMsgs.BreakupGeneratorFailed',
  'plugins.BreakupAnalysis.bottomIconLabel',
  'plugins.BreakupAnalysis.title',
  'plugins.BreakupAnalysis.helpBody',
  'plugins.BreakupAnalysis.sections.events',
  'plugins.BreakupAnalysis.sections.debrisStatistics',
  'plugins.BreakupAnalysis.sections.fragmentDispersion',
  'plugins.BreakupAnalysis.sections.trackedFragments',
  'plugins.BreakupAnalysis.sections.gabbardDiagram',
  'plugins.BreakupAnalysis.sections.actions',
  'plugins.BreakupAnalysis.actions.backToEvents',
  'plugins.BreakupAnalysis.actions.jumpToDate',
  'plugins.BreakupAnalysis.actions.selectParent',
  'plugins.BreakupAnalysis.actions.exportCsv',
  'plugins.BreakupAnalysis.actions.showAll',
  'plugins.BreakupAnalysis.actions.showFewer',
  'plugins.BreakupAnalysis.gabbard.apogee',
  'plugins.BreakupAnalysis.gabbard.perigee',
  'plugins.BreakupAnalysis.gabbard.periodAxis',
  'plugins.BreakupAnalysis.gabbard.altitudeAxis',
  'plugins.BreakupAnalysis.commands.open',
  'plugins.BreakupAnalysis.commands.export',
  'plugins.BreakupAnalysis.labels.event',
  'plugins.BreakupAnalysis.labels.date',
  'plugins.BreakupAnalysis.labels.cause',
  'plugins.BreakupAnalysis.labels.altKm',
  'plugins.BreakupAnalysis.labels.estDebris',
  'plugins.BreakupAnalysis.labels.parentObject',
  'plugins.BreakupAnalysis.labels.country',
  'plugins.BreakupAnalysis.labels.orbitType',
  'plugins.BreakupAnalysis.labels.breakupAltitude',
  'plugins.BreakupAnalysis.labels.launchDate',
  'plugins.BreakupAnalysis.labels.breakupDate',
  'plugins.BreakupAnalysis.labels.timeToBreakup',
  'plugins.BreakupAnalysis.labels.years',
  'plugins.BreakupAnalysis.labels.km',
  'plugins.BreakupAnalysis.labels.trackedDebris',
  'plugins.BreakupAnalysis.labels.estimatedTotal',
  'plugins.BreakupAnalysis.labels.trackingRatio',
  'plugins.BreakupAnalysis.labels.typeBreakdown',
  'plugins.BreakupAnalysis.labels.parameter',
  'plugins.BreakupAnalysis.labels.min',
  'plugins.BreakupAnalysis.labels.max',
  'plugins.BreakupAnalysis.labels.mean',
  'plugins.BreakupAnalysis.labels.spread',
  'plugins.BreakupAnalysis.labels.perigeeParam',
  'plugins.BreakupAnalysis.labels.apogeeParam',
  'plugins.BreakupAnalysis.labels.eccentricityParam',
  'plugins.BreakupAnalysis.labels.inclinationParam',
  'plugins.BreakupAnalysis.labels.noTrackedDebris',
  'plugins.BreakupAnalysis.labels.showingOf',
  'plugins.BreakupAnalysis.labels.norad',
  'plugins.BreakupAnalysis.labels.name',
  'plugins.BreakupAnalysis.labels.type',
  'plugins.BreakupAnalysis.labels.perigee',
  'plugins.BreakupAnalysis.labels.apogee',
  'plugins.BreakupAnalysis.labels.incDeg',
  'plugins.BreakupAnalysis.labels.ecc',
  'plugins.BreakupAnalysis.errorMsgs.parentNotFound',
  'plugins.BreakupAnalysis.errorMsgs.noDataToExport',
  'plugins.Calculator.bottomIconLabel',
  'plugins.Calculator.title',
  'plugins.Calculator.frames.geodeticLla',
  'plugins.Calculator.frames.raeTopocentric',
  'plugins.Calculator.frames.raDecGeocentric',
  'plugins.Calculator.frames.classicalElements',
  'plugins.Calculator.sections.input',
  'plugins.Calculator.labels.inputFrame',
  'plugins.Calculator.labels.loadSelectedSatellite',
  'plugins.Calculator.labels.includeVelocity',
  'plugins.Calculator.labels.convert',
  'plugins.Calculator.labels.outputFormat',
  'plugins.Calculator.labels.drawLine',
  'plugins.Calculator.labels.copyResults',
  'plugins.Calculator.labels.clickToCopy',
  'plugins.Calculator.labels.epoch',
  'plugins.Calculator.labels.sensor',
  'plugins.Calculator.labels.latitude',
  'plugins.Calculator.labels.longitude',
  'plugins.Calculator.labels.altitude',
  'plugins.Calculator.labels.range',
  'plugins.Calculator.labels.azimuth',
  'plugins.Calculator.labels.elevation',
  'plugins.Calculator.labels.rightAscension',
  'plugins.Calculator.labels.declination',
  'plugins.Calculator.labels.semiMajorAxis',
  'plugins.Calculator.labels.eccentricity',
  'plugins.Calculator.labels.inclination',
  'plugins.Calculator.labels.raan',
  'plugins.Calculator.labels.argPerigee',
  'plugins.Calculator.labels.trueAnomaly',
  'plugins.Calculator.labels.period',
  'plugins.Calculator.labels.apogeeAlt',
  'plugins.Calculator.labels.perigeeAlt',
  'plugins.Calculator.formats.fixed4',
  'plugins.Calculator.formats.fixed6',
  'plugins.Calculator.formats.fixed8',
  'plugins.Calculator.formats.scientific',
  'plugins.Calculator.formats.dms',
  'plugins.Calculator.msgs.noSensorSelected',
  'plugins.Calculator.msgs.needsVelocity',
  'plugins.Calculator.msgs.noSensorForRae',
  'plugins.Calculator.msgs.copied',
  'plugins.Calculator.errorMsgs.conversionFailed',
  'plugins.Calculator.errorMsgs.invalidInput',
  'plugins.Calculator.errorMsgs.fieldNotFound',
  'plugins.Calculator.errorMsgs.invalidNumber',
  'plugins.Calculator.errorMsgs.badEccentricity',
  'plugins.Calculator.errorMsgs.badSemiMajorAxis',
  'plugins.Calculator.errorMsgs.noSensorForRae',
  'plugins.Calculator.errorMsgs.noRaeData',
  'plugins.Calculator.errorMsgs.noSatelliteSelected',
  'plugins.Calculator.errorMsgs.notASatellite',
  'plugins.Calculator.errorMsgs.couldNotPropagate',
  'plugins.Calculator.errorMsgs.copyFailed',
  'plugins.Calculator.help.overview',
  'plugins.Calculator.help.imgAlt',
  'plugins.Calculator.help.imgCaption',
  'plugins.Calculator.help.framesHeading',
  'plugins.Calculator.help.frames',
  'plugins.Calculator.help.howToUse',
  'plugins.Calculator.help.tip1',
  'plugins.Calculator.help.tip2',
  'plugins.Calculator.help.tip3',
  'plugins.CatalogBrowserPlugin.bottomIconLabel',
  'plugins.CatalogBrowserPlugin.title',
  'plugins.CatalogBrowserPlugin.labels.loadMode',
  'plugins.CatalogBrowserPlugin.labels.allData',
  'plugins.CatalogBrowserPlugin.labels.orbitalOnly',
  'plugins.CatalogBrowserPlugin.labels.allDataDesc',
  'plugins.CatalogBrowserPlugin.labels.orbitalOnlyDesc',
  'plugins.CatalogBrowserPlugin.categories.special',
  'plugins.CatalogBrowserPlugin.categories.debris',
  'plugins.CatalogBrowserPlugin.categories.comms',
  'plugins.CatalogBrowserPlugin.categories.nav',
  'plugins.CatalogBrowserPlugin.categories.weather',
  'plugins.CatalogBrowserPlugin.categories.science',
  'plugins.CatalogBrowserPlugin.categories.keeptrack',
  'plugins.CatalogBrowserPlugin.categories.military',
  'plugins.CatalogBrowserPlugin.entries.defaultCatalog',
  'plugins.CatalogBrowserPlugin.entries.celestrakOnly',
  'plugins.CatalogBrowserPlugin.entries.vimpelOnly',
  'plugins.CatalogBrowserPlugin.entries.last30days',
  'plugins.CatalogBrowserPlugin.entries.stations',
  'plugins.CatalogBrowserPlugin.entries.iss',
  'plugins.CatalogBrowserPlugin.entries.css',
  'plugins.CatalogBrowserPlugin.entries.visual',
  'plugins.CatalogBrowserPlugin.entries.active',
  'plugins.CatalogBrowserPlugin.entries.analyst',
  'plugins.CatalogBrowserPlugin.entries.cosmos1408Debris',
  'plugins.CatalogBrowserPlugin.entries.fengyun1cDebris',
  'plugins.CatalogBrowserPlugin.entries.iridium33Debris',
  'plugins.CatalogBrowserPlugin.entries.cosmos2251Debris',
  'plugins.CatalogBrowserPlugin.entries.weather',
  'plugins.CatalogBrowserPlugin.entries.noaa',
  'plugins.CatalogBrowserPlugin.entries.goes',
  'plugins.CatalogBrowserPlugin.entries.resource',
  'plugins.CatalogBrowserPlugin.entries.sarsat',
  'plugins.CatalogBrowserPlugin.entries.dmc',
  'plugins.CatalogBrowserPlugin.entries.tdrss',
  'plugins.CatalogBrowserPlugin.entries.argos',
  'plugins.CatalogBrowserPlugin.entries.planet',
  'plugins.CatalogBrowserPlugin.entries.spire',
  'plugins.CatalogBrowserPlugin.entries.geo',
  'plugins.CatalogBrowserPlugin.entries.gpz',
  'plugins.CatalogBrowserPlugin.entries.gpzPlus',
  'plugins.CatalogBrowserPlugin.entries.intelsat',
  'plugins.CatalogBrowserPlugin.entries.ses',
  'plugins.CatalogBrowserPlugin.entries.eutelsat',
  'plugins.CatalogBrowserPlugin.entries.telesat',
  'plugins.CatalogBrowserPlugin.entries.starlink',
  'plugins.CatalogBrowserPlugin.entries.oneweb',
  'plugins.CatalogBrowserPlugin.entries.qianfan',
  'plugins.CatalogBrowserPlugin.entries.hulianwang',
  'plugins.CatalogBrowserPlugin.entries.kuiper',
  'plugins.CatalogBrowserPlugin.entries.iridiumNext',
  'plugins.CatalogBrowserPlugin.entries.iridiumSupgp',
  'plugins.CatalogBrowserPlugin.entries.orbcomm',
  'plugins.CatalogBrowserPlugin.entries.globalstar',
  'plugins.CatalogBrowserPlugin.entries.astSpaceMobile',
  'plugins.CatalogBrowserPlugin.entries.amateur',
  'plugins.CatalogBrowserPlugin.entries.satnogs',
  'plugins.CatalogBrowserPlugin.entries.xComm',
  'plugins.CatalogBrowserPlugin.entries.otherComm',
  'plugins.CatalogBrowserPlugin.entries.gnss',
  'plugins.CatalogBrowserPlugin.entries.gpsOps',
  'plugins.CatalogBrowserPlugin.entries.gloOps',
  'plugins.CatalogBrowserPlugin.entries.galileo',
  'plugins.CatalogBrowserPlugin.entries.beidou',
  'plugins.CatalogBrowserPlugin.entries.sbas',
  'plugins.CatalogBrowserPlugin.entries.nnss',
  'plugins.CatalogBrowserPlugin.entries.musson',
  'plugins.CatalogBrowserPlugin.entries.science',
  'plugins.CatalogBrowserPlugin.entries.geodetic',
  'plugins.CatalogBrowserPlugin.entries.engineering',
  'plugins.CatalogBrowserPlugin.entries.education',
  'plugins.CatalogBrowserPlugin.entries.cpf',
  'plugins.CatalogBrowserPlugin.entries.military',
  'plugins.CatalogBrowserPlugin.entries.radar',
  'plugins.CatalogBrowserPlugin.entries.cubesat',
  'plugins.CatalogBrowserPlugin.entries.other',
  'plugins.CatalogBrowserPlugin.toasts.loaded',
  'plugins.CatalogBrowserPlugin.toasts.defaultLoaded',
  'plugins.CatalogBrowserPlugin.toasts.celestrakLoaded',
  'plugins.CatalogBrowserPlugin.toasts.vimpelLoaded',
  'plugins.CatalogBrowserPlugin.commands.category',
  'plugins.CatalogBrowserPlugin.commands.loadCatalog',
  'plugins.CatalogBrowserPlugin.errorMsgs.FetchFailed',
  'plugins.CatalogBrowserPlugin.errorMsgs.DefaultFailed',
  'plugins.CatalogBrowserPlugin.errorMsgs.Forbidden',
  'plugins.CatalogBrowserPlugin.errorMsgs.RateLimited',
  'plugins.CatalogBrowserPlugin.errorMsgs.ServerError',
  'plugins.CatalogBrowserPlugin.errorMsgs.NetworkError',
  'plugins.CatalogBrowserPlugin.help.overview',
  'plugins.CatalogBrowserPlugin.help.imgAlt',
  'plugins.CatalogBrowserPlugin.help.imgCaption',
  'plugins.CatalogBrowserPlugin.help.modesHeading',
  'plugins.CatalogBrowserPlugin.help.modes',
  'plugins.CatalogBrowserPlugin.help.howToUse',
  'plugins.CatalogBrowserPlugin.help.tip1',
  'plugins.CatalogBrowserPlugin.help.tip2',
  'plugins.CatalogBrowserPlugin.help.tip3',
  'plugins.CatalogManagementPlugin.bottomIconLabel',
  'plugins.CatalogManagementPlugin.title',
  'plugins.CatalogManagementPlugin.tabs.import',
  'plugins.CatalogManagementPlugin.tabs.export',
  'plugins.CatalogManagementPlugin.labels.dropzone',
  'plugins.CatalogManagementPlugin.labels.keepSatInfo',
  'plugins.CatalogManagementPlugin.labels.keepSatInfoTooltip',
  'plugins.CatalogManagementPlugin.labels.importNewOnly',
  'plugins.CatalogManagementPlugin.labels.importNewOnlyTooltip',
  'plugins.CatalogManagementPlugin.labels.orbitalElements',
  'plugins.CatalogManagementPlugin.labels.tabularStk',
  'plugins.CatalogManagementPlugin.labels.selectedSatellite',
  'plugins.CatalogManagementPlugin.labels.tleSource',
  'plugins.CatalogManagementPlugin.labels.tleFormat',
  'plugins.CatalogManagementPlugin.labels.timeSpanHrs',
  'plugins.CatalogManagementPlugin.labels.stepSizeSec',
  'plugins.CatalogManagementPlugin.options.sourceOfficial',
  'plugins.CatalogManagementPlugin.options.sourceKeepTrack',
  'plugins.CatalogManagementPlugin.options.format2',
  'plugins.CatalogManagementPlugin.options.format3',
  'plugins.CatalogManagementPlugin.buttons.importCatalog',
  'plugins.CatalogManagementPlugin.buttons.downloadTle',
  'plugins.CatalogManagementPlugin.buttons.exportCatalogXlsx',
  'plugins.CatalogManagementPlugin.buttons.exportStkTce',
  'plugins.CatalogManagementPlugin.buttons.exportSatsInFov',
  'plugins.CatalogManagementPlugin.buttons.exportEphemeris',
  'plugins.CatalogManagementPlugin.buttons.selectSatelliteFirst',
  'plugins.CatalogManagementPlugin.toasts.noValidFileInDrop',
  'plugins.CatalogManagementPlugin.toasts.noValidTleData',
  'plugins.CatalogManagementPlugin.toasts.unsupportedFileType',
  'plugins.CatalogManagementPlugin.toasts.noNewSats',
  'plugins.CatalogManagementPlugin.toasts.addedNewSats',
  'plugins.CatalogManagementPlugin.toasts.loadedCatalog',
  'plugins.CatalogManagementPlugin.toasts.failedToLoad',
  'plugins.CatalogManagementPlugin.toasts.noSatelliteSelected',
  'plugins.CatalogManagementPlugin.toasts.exportTooLarge',
  'plugins.CatalogManagementPlugin.toasts.failedToPropagate',
  'plugins.CatalogManagementPlugin.help.overview',
  'plugins.CatalogManagementPlugin.help.imgAlt',
  'plugins.CatalogManagementPlugin.help.imgCaption',
  'plugins.CatalogManagementPlugin.help.importHeading',
  'plugins.CatalogManagementPlugin.help.import',
  'plugins.CatalogManagementPlugin.help.exportHeading',
  'plugins.CatalogManagementPlugin.help.export',
  'plugins.CatalogManagementPlugin.help.howToUse',
  'plugins.CatalogManagementPlugin.help.tip1',
  'plugins.CatalogManagementPlugin.help.tip2',
  'plugins.CloseObjectsPlugin.bottomIconLabel',
  'plugins.CloseObjectsPlugin.title',
  'plugins.CloseObjectsPlugin.sections.search',
  'plugins.CloseObjectsPlugin.findBtn',
  'plugins.CloseObjectsPlugin.help.overview',
  'plugins.CloseObjectsPlugin.help.imgAlt',
  'plugins.CloseObjectsPlugin.help.imgCaption',
  'plugins.CloseObjectsPlugin.help.methodHeading',
  'plugins.CloseObjectsPlugin.help.method',
  'plugins.CloseObjectsPlugin.help.howToUse',
  'plugins.CloseObjectsPlugin.help.tip1',
  'plugins.CloseObjectsPlugin.help.tip2',
  'plugins.CloudsToggle.bottomIconLabel',
  'plugins.CloudsToggle.commandPalette.toggle',
  'plugins.Collisions.bottomIconLabel',
  'plugins.Collisions.title',
  'plugins.Collisions.toolbar.fetchData',
  'plugins.Collisions.toolbar.refresh',
  'plugins.Collisions.table.toca',
  'plugins.Collisions.table.sat1',
  'plugins.Collisions.table.sat2',
  'plugins.Collisions.table.maxProb',
  'plugins.Collisions.table.minRange',
  'plugins.Collisions.table.relSpeed',
  'plugins.Collisions.dataSource',
  'plugins.Collisions.help.overview',
  'plugins.Collisions.help.imgAlt',
  'plugins.Collisions.help.imgCaption',
  'plugins.Collisions.help.columnsHeading',
  'plugins.Collisions.help.columns',
  'plugins.Collisions.help.howToUse',
  'plugins.Collisions.help.tip1',
  'plugins.Collisions.help.tip2',
  'plugins.Collisions.help.tip3',
  'plugins.Collisions.errorMsgs.noCollisionsData',
  'plugins.Collisions.errorMsgs.errorProcessingCollisions',
  'plugins.Collisions.labels.dataActions',
  'plugins.Collisions.labels.results',
  'plugins.ColorMenu.bottomIconLabel',
  'plugins.ColorMenu.title',
  'plugins.ColorMenu.rmbLabel',
  'plugins.ColorMenu.sectionLabel',
  'plugins.ColorMenu.help.overview',
  'plugins.ColorMenu.help.imgAlt',
  'plugins.ColorMenu.help.imgCaption',
  'plugins.ColorMenu.help.howToUse',
  'plugins.ColorMenu.help.tip1',
  'plugins.ColorMenu.help.tip2',
  'plugins.ColorMenu.help.shortcutToggle',
  'plugins.CountriesMenu.bottomIconLabel',
  'plugins.CountriesMenu.title',
  'plugins.CountriesMenu.commands.selectCountry',
  'plugins.CountriesMenu.labels.filterByCountry',
  'plugins.CountriesMenu.help.overview',
  'plugins.CountriesMenu.help.imgAlt',
  'plugins.CountriesMenu.help.imgCaption',
  'plugins.CountriesMenu.help.howToUse',
  'plugins.CountriesMenu.help.tip1',
  'plugins.CountriesMenu.help.tip2',
  'plugins.CountriesMenu.help.shortcutToggle',
  'plugins.CreateSat.bottomIconLabel',
  'plugins.CreateSat.title',
  'plugins.CreateSat.tabs.basic',
  'plugins.CreateSat.tabs.advanced',
  'plugins.CreateSat.labels.noradId',
  'plugins.CreateSat.labels.satelliteName',
  'plugins.CreateSat.labels.inclinationDeg',
  'plugins.CreateSat.labels.apogeeAltKm',
  'plugins.CreateSat.labels.perigeeAltKm',
  'plugins.CreateSat.labels.objectType',
  'plugins.CreateSat.labels.country',
  'plugins.CreateSat.labels.epochYear',
  'plugins.CreateSat.labels.epochDay',
  'plugins.CreateSat.labels.inclination',
  'plugins.CreateSat.labels.rightAscension',
  'plugins.CreateSat.labels.eccentricity',
  'plugins.CreateSat.labels.argOfPerigee',
  'plugins.CreateSat.labels.meanAnomaly',
  'plugins.CreateSat.labels.meanMotion',
  'plugins.CreateSat.labels.period',
  'plugins.CreateSat.labels.dataSource',
  'plugins.CreateSat.labels.calculatedParameters',
  'plugins.CreateSat.labels.apogeeKm',
  'plugins.CreateSat.labels.perigeeKm',
  'plugins.CreateSat.labels.smaKm',
  'plugins.CreateSat.labels.velocityKms',
  'plugins.CreateSat.labels.sectionIdentity',
  'plugins.CreateSat.labels.sectionOrbit',
  'plugins.CreateSat.labels.sectionEpoch',
  'plugins.CreateSat.labels.sectionElements',
  'plugins.CreateSat.labels.sectionPresets',
  'plugins.CreateSat.buttons.createSatellite',
  'plugins.CreateSat.buttons.saveTle',
  'plugins.CreateSat.buttons.makeSunSync',
  'plugins.CreateSat.buttons.cloneSelected',
  'plugins.CreateSat.options.payload',
  'plugins.CreateSat.options.rocketBody',
  'plugins.CreateSat.options.debris',
  'plugins.CreateSat.options.special',
  'plugins.CreateSat.options.unknown',
  'plugins.CreateSat.errorMsgs.errorCreatingSat',
  'plugins.CreateSat.errorMsgs.invalidNumericValues',
  'plugins.CreateSat.errorMsgs.perigeeTooLow',
  'plugins.CreateSat.errorMsgs.apogeeMustBeGtePerigee',
  'plugins.CreateSat.errorMsgs.inclinationRange',
  'plugins.CreateSat.errorMsgs.invalidInputParams',
  'plugins.CreateSat.errorMsgs.invalidSatObject',
  'plugins.CreateSat.errorMsgs.propagationFailed',
  'plugins.CreateSat.errorMsgs.noValidTle',
  'plugins.CreateSat.errorMsgs.exportFailed',
  'plugins.CreateSat.errorMsgs.invalidNoradId',
  'plugins.CreateSat.errorMsgs.invalidType',
  'plugins.CreateSat.errorMsgs.invalidCountry',
  'plugins.CreateSat.errorMsgs.invalidEpochYear',
  'plugins.CreateSat.errorMsgs.invalidEpochDay',
  'plugins.CreateSat.errorMsgs.invalidInclination',
  'plugins.CreateSat.errorMsgs.invalidRasc',
  'plugins.CreateSat.errorMsgs.invalidEccentricity',
  'plugins.CreateSat.errorMsgs.invalidArgPe',
  'plugins.CreateSat.errorMsgs.invalidMeanAnomaly',
  'plugins.CreateSat.errorMsgs.invalidMeanMotion',
  'plugins.CreateSat.errorMsgs.invalidPeriod',
  'plugins.CreateSat.errorMsgs.invalidSource',
  'plugins.CreateSat.errorMsgs.invalidName',
  'plugins.CreateSat.errorMsgs.slotOccupied',
  'plugins.CreateSat.errorMsgs.noFreeSlots',
  'plugins.CreateSat.errorMsgs.noSatSelected',
  'plugins.CreateSat.errorMsgs.tleChecksumMismatch',
  'plugins.CreateSat.successMsgs.satCreated',
  'plugins.CreateSat.successMsgs.tleExported',
  'plugins.CreateSat.help.overview',
  'plugins.CreateSat.help.imgAlt',
  'plugins.CreateSat.help.imgCaption',
  'plugins.CreateSat.help.tabsHeading',
  'plugins.CreateSat.help.tabs',
  'plugins.CreateSat.help.howToUse',
  'plugins.CreateSat.help.tip1',
  'plugins.CreateSat.help.tip2',
  'plugins.CreateSat.help.tip3',
  'plugins.CreateSat.presets.placeholder',
  'plugins.CreateSat.presets.selectLabel',
  'plugins.CreateSat.presets.leoIss',
  'plugins.CreateSat.presets.sso',
  'plugins.CreateSat.presets.geo',
  'plugins.CreateSat.presets.gto',
  'plugins.CreateSat.presets.molniya',
  'plugins.CreateSat.presets.polar',
  'plugins.DateTimeManager.prev',
  'plugins.DateTimeManager.next',
  'plugins.DateTimeManager.days.0',
  'plugins.DateTimeManager.days.1',
  'plugins.DateTimeManager.days.2',
  'plugins.DateTimeManager.days.3',
  'plugins.DateTimeManager.days.4',
  'plugins.DateTimeManager.days.5',
  'plugins.DateTimeManager.days.6',
  'plugins.DateTimeManager.days-short.0',
  'plugins.DateTimeManager.days-short.1',
  'plugins.DateTimeManager.days-short.2',
  'plugins.DateTimeManager.days-short.3',
  'plugins.DateTimeManager.days-short.4',
  'plugins.DateTimeManager.days-short.5',
  'plugins.DateTimeManager.days-short.6',
  'plugins.DateTimeManager.months.1',
  'plugins.DateTimeManager.months.2',
  'plugins.DateTimeManager.months.3',
  'plugins.DateTimeManager.months.4',
  'plugins.DateTimeManager.months.5',
  'plugins.DateTimeManager.months.6',
  'plugins.DateTimeManager.months.7',
  'plugins.DateTimeManager.months.8',
  'plugins.DateTimeManager.months.9',
  'plugins.DateTimeManager.months.10',
  'plugins.DateTimeManager.months.11',
  'plugins.DateTimeManager.months.12',
  'plugins.DateTimeManager.calendar.time',
  'plugins.DateTimeManager.calendar.hour',
  'plugins.DateTimeManager.calendar.minute',
  'plugins.DateTimeManager.calendar.second',
  'plugins.DateTimeManager.calendar.now',
  'plugins.DateTimeManager.calendar.done',
  'plugins.DateTimeManager.calendar.pause',
  'plugins.DateTimeManager.calendar.propagation',
  'plugins.DebrisScreening.bottomIconLabel',
  'plugins.DebrisScreening.title',
  'plugins.DebrisScreening.resultsTitle',
  'plugins.DebrisScreening.resultsCount',
  'plugins.DebrisScreening.exportCsv',
  'plugins.DebrisScreening.sections.parameters',
  'plugins.DebrisScreening.sections.searchBox',
  'plugins.DebrisScreening.sections.results',
  'plugins.DebrisScreening.riskLevels.critical',
  'plugins.DebrisScreening.riskLevels.high',
  'plugins.DebrisScreening.riskLevels.medium',
  'plugins.DebrisScreening.riskLevels.low',
  'plugins.DebrisScreening.riskLevels.unknown',
  'plugins.DebrisScreening.sccLabel',
  'plugins.DebrisScreening.timeWindowLabel',
  'plugins.DebrisScreening.timeOptions.h1',
  'plugins.DebrisScreening.timeOptions.h4',
  'plugins.DebrisScreening.timeOptions.h8',
  'plugins.DebrisScreening.timeOptions.h24',
  'plugins.DebrisScreening.timeOptions.h48',
  'plugins.DebrisScreening.timeOptions.h72',
  'plugins.DebrisScreening.uLabel',
  'plugins.DebrisScreening.vLabel',
  'plugins.DebrisScreening.wLabel',
  'plugins.DebrisScreening.screenForDebris',
  'plugins.DebrisScreening.drawBox',
  'plugins.DebrisScreening.clearBox',
  'plugins.DebrisScreening.table.secondary',
  'plugins.DebrisScreening.table.tca',
  'plugins.DebrisScreening.table.missKm',
  'plugins.DebrisScreening.table.rKm',
  'plugins.DebrisScreening.table.iKm',
  'plugins.DebrisScreening.table.cKm',
  'plugins.DebrisScreening.table.pc',
  'plugins.DebrisScreening.table.risk',
  'plugins.DebrisScreening.errorMsgs.InvalidSatellite',
  'plugins.DebrisScreening.errorMsgs.ScreeningFailed',
  'plugins.DebrisScreening.errorMsgs.NoResultsToExport',
  'plugins.DebrisScreening.help.overview',
  'plugins.DebrisScreening.help.imgAlt',
  'plugins.DebrisScreening.help.imgCaption',
  'plugins.DebrisScreening.help.boxHeading',
  'plugins.DebrisScreening.help.box',
  'plugins.DebrisScreening.help.resultsHeading',
  'plugins.DebrisScreening.help.results',
  'plugins.DebrisScreening.help.howToUse',
  'plugins.DebrisScreening.help.tip1',
  'plugins.DebrisScreening.help.tip2',
  'plugins.DebrisScreening.help.tip3',
  'plugins.DopsPlugin.bottomIconLabel',
  'plugins.DopsPlugin.title',
  'plugins.DopsPlugin.labels.dopTable',
  'plugins.DopsPlugin.labels.latitude',
  'plugins.DopsPlugin.labels.longitude',
  'plugins.DopsPlugin.labels.altitude',
  'plugins.DopsPlugin.labels.mask',
  'plugins.DopsPlugin.labels.updateDopData',
  'plugins.DopsPlugin.labels.location',
  'plugins.DopsPlugin.labels.results',
  'plugins.DopsPlugin.tooltips.latitude',
  'plugins.DopsPlugin.tooltips.longitude',
  'plugins.DopsPlugin.tooltips.altitude',
  'plugins.DopsPlugin.tooltips.mask',
  'plugins.DopsPlugin.table.time',
  'plugins.DopsPlugin.table.hdop',
  'plugins.DopsPlugin.table.pdop',
  'plugins.DopsPlugin.table.gdop',
  'plugins.DopsPlugin.rmb.dops',
  'plugins.DopsPlugin.rmb.currentGpsDops',
  'plugins.DopsPlugin.rmb.twentyFourHourGpsDops',
  'plugins.DopsPlugin.toast.dopValues',
  'plugins.DopsPlugin.errorMsgs.invalidLocation',
  'plugins.DopsPlugin.help.overview',
  'plugins.DopsPlugin.help.imgAlt',
  'plugins.DopsPlugin.help.imgCaption',
  'plugins.DopsPlugin.help.valuesHeading',
  'plugins.DopsPlugin.help.values',
  'plugins.DopsPlugin.help.howToUse',
  'plugins.DopsPlugin.help.tip1',
  'plugins.DopsPlugin.help.tip2',
  'plugins.DopsPlugin.help.tip3',
  'plugins.DopsPlugin.help.shortcutToggle',
  'plugins.DrawLinesPlugin.title',
  'plugins.DrawLinesPlugin.bottomIconLabel',
  'plugins.DrawLinesPlugin.rmbMenu.title',
  'plugins.DrawLinesPlugin.rmbMenu.eciAxes',
  'plugins.DrawLinesPlugin.rmbMenu.xAxesGrid',
  'plugins.DrawLinesPlugin.rmbMenu.yAxesGrid',
  'plugins.DrawLinesPlugin.rmbMenu.zAxesGrid',
  'plugins.DrawLinesPlugin.rmbMenu.xAxesRadialGrid',
  'plugins.DrawLinesPlugin.rmbMenu.yAxesRadialGrid',
  'plugins.DrawLinesPlugin.rmbMenu.zAxesRadialGrid',
  'plugins.DrawLinesPlugin.rmbMenu.earthToSatellite',
  'plugins.DrawLinesPlugin.rmbMenu.sensorToSatellite',
  'plugins.DrawLinesPlugin.rmbMenu.satelliteToSatellite',
  'plugins.DrawLinesPlugin.rmbMenu.satelliteRicAxes',
  'plugins.DrawLinesPlugin.rmbMenu.satelliteToSun',
  'plugins.DrawLinesPlugin.rmbMenu.satelliteToMoon',
  'plugins.DrawLinesPlugin.rmbMenu.moonOrbit',
  'plugins.DrawLinesPlugin.sections.activeLines',
  'plugins.DrawLinesPlugin.sections.referenceGeometry',
  'plugins.DrawLinesPlugin.sections.objectLines',
  'plugins.DrawLinesPlugin.referenceFrameLabel',
  'plugins.DrawLinesPlugin.clearAll',
  'plugins.DrawLinesPlugin.emptyList',
  'plugins.DrawLinesPlugin.remove',
  'plugins.DrawLinesPlugin.lineTypes.reference',
  'plugins.DrawLinesPlugin.lineTypes.satToRef',
  'plugins.DrawLinesPlugin.lineTypes.satRic',
  'plugins.DrawLinesPlugin.lineTypes.objToObj',
  'plugins.DrawLinesPlugin.lineTypes.satToSun',
  'plugins.DrawLinesPlugin.lineTypes.satToBody',
  'plugins.DrawLinesPlugin.lineTypes.sensorToSat',
  'plugins.DrawLinesPlugin.lineTypes.sensorToSun',
  'plugins.DrawLinesPlugin.lineTypes.sensorToMoon',
  'plugins.DrawLinesPlugin.lineTypes.orbitPath',
  'plugins.DrawLinesPlugin.lineTypes.satScanEarth',
  'plugins.DrawLinesPlugin.lineTypes.sensorScanHorizon',
  'plugins.DrawLinesPlugin.lineTypes.sensorToRae',
  'plugins.DrawLinesPlugin.lineTypes.generic',
  'plugins.DrawLinesPlugin.lineTypes.sensorMarker',
  'plugins.DrawLinesPlugin.errorMsgs.noPrimarySat',
  'plugins.DrawLinesPlugin.errorMsgs.noSatSelected',
  'plugins.EarthCenteredView.bottomIconLabel',
  'plugins.EarthPresetsPlugin.rmbMenu.title',
  'plugins.EarthPresetsPlugin.rmbMenu.satelliteImages',
  'plugins.EarthPresetsPlugin.rmbMenu.alternateSatelliteImages',
  'plugins.EarthPresetsPlugin.rmbMenu.engineeringTool',
  'plugins.EarthPresetsPlugin.rmbMenu.operationsCenter',
  'plugins.EarthPresetsPlugin.rmbMenu.nineties',
  'plugins.EditSat.bottomIconLabel',
  'plugins.EditSat.title',
  'plugins.EditSat.help.overview',
  'plugins.EditSat.help.imgAlt',
  'plugins.EditSat.help.imgCaption',
  'plugins.EditSat.help.fieldsHeading',
  'plugins.EditSat.help.fields',
  'plugins.EditSat.help.howToUse',
  'plugins.EditSat.help.tip1',
  'plugins.EditSat.help.tip2',
  'plugins.EditSat.help.tip3',
  'plugins.EditSat.help.shortcutToggle',
  'plugins.EditSat.sections.identity',
  'plugins.EditSat.sections.epoch',
  'plugins.EditSat.sections.elements',
  'plugins.EditSat.sections.calculated',
  'plugins.EditSat.sections.actions',
  'plugins.EditSat.labels.apogeeKm',
  'plugins.EditSat.labels.perigeeKm',
  'plugins.EditSat.labels.periodMin',
  'plugins.EditSat.labels.scc',
  'plugins.EditSat.labels.country',
  'plugins.EditSat.labels.epochYear',
  'plugins.EditSat.labels.epochDay',
  'plugins.EditSat.labels.inclination',
  'plugins.EditSat.labels.rightAscension',
  'plugins.EditSat.labels.eccentricity',
  'plugins.EditSat.labels.argOfPerigee',
  'plugins.EditSat.labels.meanAnomaly',
  'plugins.EditSat.labels.meanMotion',
  'plugins.EditSat.labels.period',
  'plugins.EditSat.labels.error',
  'plugins.EditSat.buttons.resetOriginal',
  'plugins.EditSat.buttons.updateSatellite',
  'plugins.EditSat.buttons.updateEpoch',
  'plugins.EditSat.buttons.saveTle',
  'plugins.EditSat.buttons.loadTle',
  'plugins.EditSat.contextMenu.editSat',
  'plugins.EditSat.contextMenu.setSecondarySat',
  'plugins.EditSat.contextMenu.editSatellite',
  'plugins.EditSat.errorMsgs.errorReadingFile',
  'plugins.EditSat.errorMsgs.satelliteNotFound',
  'plugins.EditSat.errorMsgs.failedToPropagate',
  'plugins.EditSat.errorMsgs.cannotCalculateDirection',
  'plugins.EditSat.errorMsgs.notRealSatellite',
  'plugins.FilterMenuPlugin.title',
  'plugins.FilterMenuPlugin.bottomIconLabel',
  'plugins.FilterMenuPlugin.help.overview',
  'plugins.FilterMenuPlugin.help.imgAlt',
  'plugins.FilterMenuPlugin.help.imgCaption',
  'plugins.FilterMenuPlugin.help.howToUse',
  'plugins.FilterMenuPlugin.help.tip1',
  'plugins.FilterMenuPlugin.help.tip2',
  'plugins.FilterMenuPlugin.help.shortcutToggle',
  'plugins.FilterMenuPlugin.resetToDefaults',
  'plugins.FilterMenuPlugin.defaultTooltip',
  'plugins.FilterMenuPlugin.searchPlaceholder',
  'plugins.FilterMenuPlugin.commands.category',
  'plugins.FilterMenuPlugin.commands.open',
  'plugins.FilterMenuPlugin.commands.resetDefaults',
  'plugins.FilterMenuPlugin.commands.toggleDebris',
  'plugins.FilterMenuPlugin.commands.toggleRocketBodies',
  'plugins.FilterMenuPlugin.commands.toggleUnknownType',
  'plugins.FilterMenuPlugin.commands.toggleNotional',
  'plugins.FilterMenuPlugin.commands.toggleStarlink',
  'plugins.FilterMenuPlugin.commands.showOnlyPayloads',
  'plugins.FilterMenuPlugin.commands.hideDebrisAndRocketBodies',
  'plugins.FilterMenuPlugin.commands.showAllObjectTypes',
  'plugins.FilterMenuPlugin.commands.hideAllObjectTypes',
  'plugins.FilterMenuPlugin.commands.toggleLEO',
  'plugins.FilterMenuPlugin.commands.toggleMEO',
  'plugins.FilterMenuPlugin.commands.toggleGEO',
  'plugins.FilterMenuPlugin.commands.toggleHEO',
  'plugins.FilterMenuPlugin.commands.showOnlyLEO',
  'plugins.FilterMenuPlugin.commands.showOnlyGEO',
  'plugins.FilterMenuPlugin.commands.showAllOrbitalRegimes',
  'plugins.FilterMenuPlugin.commands.showOnlyCelestrak',
  'plugins.FilterMenuPlugin.commands.showAllSources',
  'plugins.FilterMenuPlugin.commands.showOnlyUS',
  'plugins.FilterMenuPlugin.commands.showOnlyRussia',
  'plugins.FilterMenuPlugin.commands.showOnlyChina',
  'plugins.FilterMenuPlugin.commands.showAllCountries',
  'plugins.FilterMenuPlugin.commands.hideAllCountries',
  'plugins.FindSatPlugin.bottomIconLabel',
  'plugins.FindSatPlugin.title',
  'plugins.FindSatPlugin.help.overview',
  'plugins.FindSatPlugin.help.imgAlt',
  'plugins.FindSatPlugin.help.imgCaption',
  'plugins.FindSatPlugin.help.filtersHeading',
  'plugins.FindSatPlugin.help.filters',
  'plugins.FindSatPlugin.help.howToUse',
  'plugins.FindSatPlugin.help.tip1',
  'plugins.FindSatPlugin.help.tip2',
  'plugins.FindSatPlugin.help.tip3',
  'plugins.FindSatPlugin.help.tip4',
  'plugins.FindSatPlugin.help.shortcutToggle',
  'plugins.FindSatPlugin.labels.typePayload',
  'plugins.FindSatPlugin.labels.typeRocketBody',
  'plugins.FindSatPlugin.labels.typeDebris',
  'plugins.FindSatPlugin.labels.busFilterPlaceholder',
  'plugins.FindSatPlugin.labels.satelliteBusFilter',
  'plugins.FindSatPlugin.labels.payloadFilterPlaceholder',
  'plugins.FindSatPlugin.labels.payloadFilter',
  'plugins.FindSatPlugin.labels.objectType',
  'plugins.FindSatPlugin.labels.country',
  'plugins.FindSatPlugin.labels.satelliteBus',
  'plugins.FindSatPlugin.labels.payload',
  'plugins.FindSatPlugin.labels.shape',
  'plugins.FindSatPlugin.labels.source',
  'plugins.FindSatPlugin.labels.azimuth',
  'plugins.FindSatPlugin.labels.azimuthMargin',
  'plugins.FindSatPlugin.labels.elevation',
  'plugins.FindSatPlugin.labels.elevationMargin',
  'plugins.FindSatPlugin.labels.range',
  'plugins.FindSatPlugin.labels.rangeMargin',
  'plugins.FindSatPlugin.labels.inclination',
  'plugins.FindSatPlugin.labels.inclinationMargin',
  'plugins.FindSatPlugin.labels.period',
  'plugins.FindSatPlugin.labels.periodMargin',
  'plugins.FindSatPlugin.labels.tleAge',
  'plugins.FindSatPlugin.labels.tleAgeMargin',
  'plugins.FindSatPlugin.labels.rcs',
  'plugins.FindSatPlugin.labels.rcsMargin',
  'plugins.FindSatPlugin.labels.rightAscension',
  'plugins.FindSatPlugin.labels.rightAscensionMargin',
  'plugins.FindSatPlugin.labels.argOfPerigee',
  'plugins.FindSatPlugin.labels.argOfPerigeeMargin',
  'plugins.FindSatPlugin.labels.all',
  'plugins.FindSatPlugin.labels.findSatellites',
  'plugins.FindSatPlugin.labels.exportData',
  'plugins.FindSatPlugin.labels.sectionClassification',
  'plugins.FindSatPlugin.labels.sectionLookAngles',
  'plugins.FindSatPlugin.labels.sectionOrbital',
  'plugins.FindSatPlugin.labels.sectionPhysical',
  'plugins.FindSatPlugin.labels.sensorNote',
  'plugins.FindSatPlugin.labels.resultCount',
  'plugins.FindSatPlugin.errorMsgs.NoSatellitesFound',
  'plugins.FindSatPlugin.errorMsgs.NoSearchCriteriaEntered',
  'plugins.FindSatPlugin.errorMsgs.TooManyResults',
  'plugins.FindSatPlugin.errorMsgs.TryFindingFirst',
  'plugins.FindSatPlugin.errorMsgs.SearchFailed',
  'plugins.FpsView.bottomIconLabel',
  'plugins.GamepadPlugin.connected',
  'plugins.GamepadPlugin.disconnected',
  'plugins.GithubLinkPlugin.tooltip',
  'plugins.GraticuleToggle.bottomIconLabel',
  'plugins.GraticuleToggle.commandPalette.toggle',
  'plugins.GunterLaunchCalendar.bottomIconLabel',
  'plugins.GunterLaunchCalendar.title',
  'plugins.GunterLaunchCalendar.commands.open',
  'plugins.GunterLaunchCalendar.help.overview',
  'plugins.GunterLaunchCalendar.help.howToUse',
  'plugins.GunterLaunchCalendar.help.tip1',
  'plugins.GunterLaunchCalendar.help.tip2',
  'plugins.HideOtherSatellitesPlugin.bottomIconLabel',
  'plugins.HideOtherSatellitesPlugin.commandPalette.toggle',
  'plugins.LinkedInLinkPlugin.tooltip',
  'plugins.MissileSimulatorPlugin.bottomIconLabel',
  'plugins.MissileSimulatorPlugin.title',
  'plugins.MissileSimulatorPlugin.labels.typeOfAttack',
  'plugins.MissileSimulatorPlugin.labels.launchLocation',
  'plugins.MissileSimulatorPlugin.labels.targetLocation',
  'plugins.MissileSimulatorPlugin.labels.customLaunchLatitude',
  'plugins.MissileSimulatorPlugin.labels.customLaunchLongitude',
  'plugins.MissileSimulatorPlugin.labels.customTargetLatitude',
  'plugins.MissileSimulatorPlugin.labels.customTargetLongitude',
  'plugins.MissileSimulatorPlugin.labels.warheads',
  'plugins.MissileSimulatorPlugin.types.customMissile',
  'plugins.MissileSimulatorPlugin.types.russiaToUsa',
  'plugins.MissileSimulatorPlugin.types.russiaToUsaSubs',
  'plugins.MissileSimulatorPlugin.types.chinaToUsa',
  'plugins.MissileSimulatorPlugin.types.northKoreaToUsa',
  'plugins.MissileSimulatorPlugin.types.usaToRussia',
  'plugins.MissileSimulatorPlugin.types.usaToChina',
  'plugins.MissileSimulatorPlugin.types.usaToNorthKorea',
  'plugins.MissileSimulatorPlugin.types.exchangeUsaRussia',
  'plugins.MissileSimulatorPlugin.types.exchangeUsaChina',
  'plugins.MissileSimulatorPlugin.types.exchangeUsaNorthKorea',
  'plugins.MissileSimulatorPlugin.types.exchangeChinaIndia',
  'plugins.MissileSimulatorPlugin.types.globalThermonuclearWar',
  'plugins.MissileSimulatorPlugin.types.iranToIsrael',
  'plugins.MissileSimulatorPlugin.types.israelToIran',
  'plugins.MissileSimulatorPlugin.types.exchangeIranIsrael',
  'plugins.MissileSimulatorPlugin.types.exchangeRussiaUkraine',
  'plugins.MissileSimulatorPlugin.types.exchangeIndiaPakistan',
  'plugins.MissileSimulatorPlugin.types.russiaToUkraine',
  'plugins.MissileSimulatorPlugin.types.ukraineToRussia',
  'plugins.MissileSimulatorPlugin.typeGroups.strategic',
  'plugins.MissileSimulatorPlugin.typeGroups.exchanges',
  'plugins.MissileSimulatorPlugin.typeGroups.regional',
  'plugins.MissileSimulatorPlugin.groups.russia',
  'plugins.MissileSimulatorPlugin.groups.china',
  'plugins.MissileSimulatorPlugin.groups.unitedStates',
  'plugins.MissileSimulatorPlugin.groups.unitedKingdom',
  'plugins.MissileSimulatorPlugin.groups.france',
  'plugins.MissileSimulatorPlugin.groups.northKorea',
  'plugins.MissileSimulatorPlugin.groups.natoCountries',
  'plugins.MissileSimulatorPlugin.groups.nonNatoCountries',
  'plugins.MissileSimulatorPlugin.groups.usMilitaryBases',
  'plugins.MissileSimulatorPlugin.groups.usLargestCities',
  'plugins.MissileSimulatorPlugin.groups.russiaMilitaryBases',
  'plugins.MissileSimulatorPlugin.groups.russiaLargestCities',
  'plugins.MissileSimulatorPlugin.groups.chinaMilitaryBases',
  'plugins.MissileSimulatorPlugin.groups.chinaLargestCities',
  'plugins.MissileSimulatorPlugin.attackers.aleysk',
  'plugins.MissileSimulatorPlugin.attackers.dombarovskiy',
  'plugins.MissileSimulatorPlugin.attackers.uzhur',
  'plugins.MissileSimulatorPlugin.attackers.kartaly',
  'plugins.MissileSimulatorPlugin.attackers.irkutsk',
  'plugins.MissileSimulatorPlugin.attackers.kansk',
  'plugins.MissileSimulatorPlugin.attackers.krasnoyarsk',
  'plugins.MissileSimulatorPlugin.attackers.nizhniyTagil',
  'plugins.MissileSimulatorPlugin.attackers.novosibirsk',
  'plugins.MissileSimulatorPlugin.attackers.tatischevoSs19',
  'plugins.MissileSimulatorPlugin.attackers.tatischevoSs27',
  'plugins.MissileSimulatorPlugin.attackers.teykovo',
  'plugins.MissileSimulatorPlugin.attackers.yoshkarOla',
  'plugins.MissileSimulatorPlugin.attackers.boreiSub',
  'plugins.MissileSimulatorPlugin.attackers.deltaIvSubSineva',
  'plugins.MissileSimulatorPlugin.attackers.deltaIvSubLayner',
  'plugins.MissileSimulatorPlugin.attackers.type092Sub',
  'plugins.MissileSimulatorPlugin.attackers.nanyang',
  'plugins.MissileSimulatorPlugin.attackers.xining',
  'plugins.MissileSimulatorPlugin.attackers.delingha',
  'plugins.MissileSimulatorPlugin.attackers.haiyan',
  'plugins.MissileSimulatorPlugin.attackers.datong',
  'plugins.MissileSimulatorPlugin.attackers.tainshui',
  'plugins.MissileSimulatorPlugin.attackers.xixia',
  'plugins.MissileSimulatorPlugin.attackers.shaoyang',
  'plugins.MissileSimulatorPlugin.attackers.yuxi',
  'plugins.MissileSimulatorPlugin.attackers.luoyang',
  'plugins.MissileSimulatorPlugin.attackers.wuzhai',
  'plugins.MissileSimulatorPlugin.attackers.xuanhua',
  'plugins.MissileSimulatorPlugin.attackers.tongdao',
  'plugins.MissileSimulatorPlugin.attackers.lushi',
  'plugins.MissileSimulatorPlugin.attackers.jingxianA',
  'plugins.MissileSimulatorPlugin.attackers.jingxianB',
  'plugins.MissileSimulatorPlugin.attackers.hunan',
  'plugins.MissileSimulatorPlugin.attackers.daqingCity',
  'plugins.MissileSimulatorPlugin.attackers.xinyangCity',
  'plugins.MissileSimulatorPlugin.attackers.xinjiangProvince',
  'plugins.MissileSimulatorPlugin.attackers.tibetProvince',
  'plugins.MissileSimulatorPlugin.attackers.minot',
  'plugins.MissileSimulatorPlugin.attackers.malmstrom',
  'plugins.MissileSimulatorPlugin.attackers.feWarren',
  'plugins.MissileSimulatorPlugin.attackers.ohioSub',
  'plugins.MissileSimulatorPlugin.attackers.vanguardSub',
  'plugins.MissileSimulatorPlugin.attackers.hmnbClyde',
  'plugins.MissileSimulatorPlugin.attackers.triomphantSub',
  'plugins.MissileSimulatorPlugin.attackers.bayOfBiscay',
  'plugins.MissileSimulatorPlugin.attackers.sinpoSub',
  'plugins.MissileSimulatorPlugin.attackers.sinpo',
  'plugins.MissileSimulatorPlugin.attackers.pyongan',
  'plugins.MissileSimulatorPlugin.attackers.pyongyang',
  'plugins.MissileSimulatorPlugin.targets.washingtonDc',
  'plugins.MissileSimulatorPlugin.targets.newYorkCity',
  'plugins.MissileSimulatorPlugin.targets.losAngeles',
  'plugins.MissileSimulatorPlugin.targets.chicago',
  'plugins.MissileSimulatorPlugin.targets.boston',
  'plugins.MissileSimulatorPlugin.targets.seattle',
  'plugins.MissileSimulatorPlugin.targets.miami',
  'plugins.MissileSimulatorPlugin.targets.dallas',
  'plugins.MissileSimulatorPlugin.targets.coloradoSprings',
  'plugins.MissileSimulatorPlugin.targets.omaha',
  'plugins.MissileSimulatorPlugin.targets.hawaii',
  'plugins.MissileSimulatorPlugin.targets.guam',
  'plugins.MissileSimulatorPlugin.targets.customImpact',
  'plugins.MissileSimulatorPlugin.targets.london',
  'plugins.MissileSimulatorPlugin.targets.paris',
  'plugins.MissileSimulatorPlugin.targets.frenchCaribbean',
  'plugins.MissileSimulatorPlugin.targets.madrid',
  'plugins.MissileSimulatorPlugin.targets.rome',
  'plugins.MissileSimulatorPlugin.targets.berlin',
  'plugins.MissileSimulatorPlugin.targets.toronto',
  'plugins.MissileSimulatorPlugin.targets.moscow',
  'plugins.MissileSimulatorPlugin.targets.stPetersburg',
  'plugins.MissileSimulatorPlugin.targets.novosibirsk',
  'plugins.MissileSimulatorPlugin.targets.beijing',
  'plugins.MissileSimulatorPlugin.targets.pyongyang',
  'plugins.MissileSimulatorPlugin.buttons.launchMissileAttack',
  'plugins.MissileSimulatorPlugin.buttons.showAllMissiles',
  'plugins.MissileSimulatorPlugin.buttons.clearMissiles',
  'plugins.MissileSimulatorPlugin.msgs.simLoaded',
  'plugins.MissileSimulatorPlugin.msgs.simLoadFailed',
  'plugins.MissileSimulatorPlugin.msgs.missilesActive',
  'plugins.MissileSimulatorPlugin.errorMsgs.invalidTargetLatitude',
  'plugins.MissileSimulatorPlugin.errorMsgs.invalidTargetLongitude',
  'plugins.MissileSimulatorPlugin.errorMsgs.invalidLaunchLatitude',
  'plugins.MissileSimulatorPlugin.errorMsgs.invalidLaunchLongitude',
  'plugins.MissileSimulatorPlugin.errorMsgs.invalidWarheads',
  'plugins.MissileSimulatorPlugin.commands.open',
  'plugins.MissileSimulatorPlugin.commands.showAllMissiles',
  'plugins.MissileSimulatorPlugin.commands.clearMissiles',
  'plugins.MissileSimulatorPlugin.help.overview',
  'plugins.MissileSimulatorPlugin.help.imgAlt',
  'plugins.MissileSimulatorPlugin.help.imgCaption',
  'plugins.MissileSimulatorPlugin.help.typesHeading',
  'plugins.MissileSimulatorPlugin.help.types',
  'plugins.MissileSimulatorPlugin.help.howToUse',
  'plugins.MissileSimulatorPlugin.help.tip1',
  'plugins.MissileSimulatorPlugin.help.tip2',
  'plugins.MissileSimulatorPlugin.help.tip3',
  'plugins.MissileSimulatorPlugin.sections.attackType',
  'plugins.MissileSimulatorPlugin.sections.launch',
  'plugins.MissileSimulatorPlugin.sections.target',
  'plugins.NewLaunch.bottomIconLabel',
  'plugins.NewLaunch.title',
  'plugins.NewLaunch.sideMenuTitle',
  'plugins.NewLaunch.leoOptimizedNote',
  'plugins.NewLaunch.labels.satelliteScc',
  'plugins.NewLaunch.labels.inclination',
  'plugins.NewLaunch.labels.launchingNorthOrSouth',
  'plugins.NewLaunch.labels.launchFacility',
  'plugins.NewLaunch.labels.north',
  'plugins.NewLaunch.labels.south',
  'plugins.NewLaunch.sections.template',
  'plugins.NewLaunch.sections.launchWindow',
  'plugins.NewLaunch.sections.launchSite',
  'plugins.NewLaunch.buttons.matchTargetPlane',
  'plugins.NewLaunch.buttons.createLaunchNominal',
  'plugins.NewLaunch.buttons.inclinationTooLow',
  'plugins.NewLaunch.buttons.clearWindow',
  'plugins.NewLaunch.buttons.createLaunchAtWindow',
  'plugins.NewLaunch.msgs.windowFound',
  'plugins.NewLaunch.msgs.launchNominalCreated',
  'plugins.NewLaunch.msgs.timeRelativeToLaunch',
  'plugins.NewLaunch.errorMsgs.windowNoTarget',
  'plugins.NewLaunch.errorMsgs.windowGeometryImpossible',
  'plugins.NewLaunch.errorMsgs.noMoreNominalSatellites',
  'plugins.NewLaunch.errorMsgs.launchSiteNotFound',
  'plugins.NewLaunch.errorMsgs.failedToCreateTle',
  'plugins.NewLaunch.errorMsgs.invalidTle1Length',
  'plugins.NewLaunch.errorMsgs.invalidTle2Length',
  'plugins.NewLaunch.errorMsgs.failedAltitudeTest',
  'plugins.NewLaunch.errorMsgs.cruncherFailed',
  'plugins.NewLaunch.errorMsgs.errorCreatingSatRecord',
  'plugins.NewLaunch.errorMsgs.launchSiteNotInCatalog',
  'plugins.NewLaunch.errorMsgs.invalidEccentricityFormat',
  'plugins.NewLaunch.errorMsgs.eccentricityFormatIssue',
  'plugins.NewLaunch.errorMsgs.invalidEpochYearFormat',
  'plugins.NewLaunch.errorMsgs.epochYearFormatIssue',
  'plugins.NewLaunch.errorMsgs.invalidEpochDayFormat',
  'plugins.NewLaunch.errorMsgs.epochDayFormatIssue',
  'plugins.NewLaunch.errorMsgs.failedToPropagate',
  'plugins.NewLaunch.errorMsgs.changingOrbitBufferFailed',
  'plugins.NewLaunch.errorMsgs.launchLatExceedsInclination',
  'plugins.NewLaunch.errorMsgs.failedToFitOrbit',
  'plugins.NewLaunch.help.overview',
  'plugins.NewLaunch.help.imgAlt',
  'plugins.NewLaunch.help.imgCaption',
  'plugins.NewLaunch.help.howToUse',
  'plugins.NewLaunch.help.limitsHeading',
  'plugins.NewLaunch.help.limits',
  'plugins.NewLaunch.help.tip1',
  'plugins.NewLaunch.help.tip2',
  'plugins.NewLaunch.help.shortcutOpen',
  'plugins.NewLaunch.launchWindowHelp',
  'plugins.OnboardingPlugin.bottomIconLabel',
  'plugins.OnboardingPlugin.title',
  'plugins.OnboardingPlugin.helpBody',
  'plugins.OnboardingPlugin.stepLabel',
  'plugins.OnboardingPlugin.buttons.next',
  'plugins.OnboardingPlugin.buttons.back',
  'plugins.OnboardingPlugin.buttons.skipTour',
  'plugins.OnboardingPlugin.buttons.skipConfirm',
  'plugins.OnboardingPlugin.buttons.skipYes',
  'plugins.OnboardingPlugin.buttons.skipNo',
  'plugins.OnboardingPlugin.buttons.startTour',
  'plugins.OnboardingPlugin.buttons.exploreOnMyOwn',
  'plugins.OnboardingPlugin.buttons.keepGoing',
  'plugins.OnboardingPlugin.buttons.finishUp',
  'plugins.OnboardingPlugin.buttons.createAccount',
  'plugins.OnboardingPlugin.buttons.maybeLater',
  'plugins.OnboardingPlugin.buttons.doItForMe',
  'plugins.OnboardingPlugin.buttons.openIt',
  'plugins.OnboardingPlugin.welcome.title',
  'plugins.OnboardingPlugin.welcome.body',
  'plugins.OnboardingPlugin.welcome.personaQuestion',
  'plugins.OnboardingPlugin.personas.explorer',
  'plugins.OnboardingPlugin.personas.student',
  'plugins.OnboardingPlugin.personas.operator',
  'plugins.OnboardingPlugin.personas.developer',
  'plugins.OnboardingPlugin.steps.b1Globe.title',
  'plugins.OnboardingPlugin.steps.b1Globe.body',
  'plugins.OnboardingPlugin.steps.b2Zoom.title',
  'plugins.OnboardingPlugin.steps.b2Zoom.body',
  'plugins.OnboardingPlugin.steps.b3Search.title',
  'plugins.OnboardingPlugin.steps.b3Search.body',
  'plugins.OnboardingPlugin.steps.b4Select.title',
  'plugins.OnboardingPlugin.steps.b4Select.body',
  'plugins.OnboardingPlugin.steps.b5Infobox.title',
  'plugins.OnboardingPlugin.steps.b5Infobox.body',
  'plugins.OnboardingPlugin.steps.b6Time.title',
  'plugins.OnboardingPlugin.steps.b6Time.body',
  'plugins.OnboardingPlugin.steps.b7Drawer.title',
  'plugins.OnboardingPlugin.steps.b7Drawer.body',
  'plugins.OnboardingPlugin.bridge.title',
  'plugins.OnboardingPlugin.bridge.body',
  'plugins.OnboardingPlugin.bridge.recap1',
  'plugins.OnboardingPlugin.bridge.recap2',
  'plugins.OnboardingPlugin.bridge.recap3',
  'plugins.OnboardingPlugin.account.title',
  'plugins.OnboardingPlugin.account.body',
  'plugins.OnboardingPlugin.account.bodyPower',
  'plugins.OnboardingPlugin.account.benefit1',
  'plugins.OnboardingPlugin.account.benefit2',
  'plugins.OnboardingPlugin.account.benefit3',
  'plugins.OnboardingPlugin.toasts.restartHint',
  'plugins.OnboardingPlugin.toasts.accountCreated',
  'plugins.OnboardingPlugin.toasts.finished',
  'plugins.OnboardingPlugin.toasts.allChaptersDone',
  'plugins.OnboardingPlugin.card.title',
  'plugins.OnboardingPlugin.card.allSet',
  'plugins.OnboardingPlugin.card.dismiss',
  'plugins.OnboardingPlugin.checklist.powerTour',
  'plugins.OnboardingPlugin.checklist.watchlist3',
  'plugins.OnboardingPlugin.checklist.selectSensor',
  'plugins.OnboardingPlugin.checklist.lookAngles',
  'plugins.OnboardingPlugin.checklist.colorScheme',
  'plugins.OnboardingPlugin.menu.missionsLabel',
  'plugins.OnboardingPlugin.menu.toursLabel',
  'plugins.OnboardingPlugin.menu.restoreCard',
  'plugins.OnboardingPlugin.commands.startTour',
  'plugins.OnboardingPlugin.commands.startPowerTour',
  'plugins.OnboardingPlugin.commands.openChecklist',
  'plugins.OnboardingPlugin.settings.showOnFirstRun',
  'plugins.OnboardingPlugin.settings.restartTutorial',
  'plugins.OnboardingPlugin.settings.restartTutorialButton',
  'plugins.OnboardingPlugin.chapters.essentials.steps.drawerGroups.title',
  'plugins.OnboardingPlugin.chapters.essentials.steps.drawerGroups.body',
  'plugins.OnboardingPlugin.chapters.essentials.steps.commandPalette.title',
  'plugins.OnboardingPlugin.chapters.essentials.steps.commandPalette.body',
  'plugins.OnboardingPlugin.chapters.essentials.steps.utility.title',
  'plugins.OnboardingPlugin.chapters.essentials.steps.utility.body',
  'plugins.OnboardingPlugin.chapters.essentials.steps.help.title',
  'plugins.OnboardingPlugin.chapters.essentials.steps.help.body',
  'plugins.OnboardingPlugin.chapters.essentials.title',
  'plugins.OnboardingPlugin.chapters.essentials.description',
  'plugins.OnboardingPlugin.chapters.sensors.title',
  'plugins.OnboardingPlugin.chapters.sensors.description',
  'plugins.OnboardingPlugin.chapters.sensors.demoCustomSensorName',
  'plugins.OnboardingPlugin.chapters.sensors.steps.openList.title',
  'plugins.OnboardingPlugin.chapters.sensors.steps.openList.body',
  'plugins.OnboardingPlugin.chapters.sensors.steps.selectSensor.title',
  'plugins.OnboardingPlugin.chapters.sensors.steps.selectSensor.body',
  'plugins.OnboardingPlugin.chapters.sensors.steps.coverage.title',
  'plugins.OnboardingPlugin.chapters.sensors.steps.coverage.body',
  'plugins.OnboardingPlugin.chapters.sensors.steps.fovLayer.title',
  'plugins.OnboardingPlugin.chapters.sensors.steps.fovLayer.body',
  'plugins.OnboardingPlugin.chapters.sensors.steps.sensorInfo.title',
  'plugins.OnboardingPlugin.chapters.sensors.steps.sensorInfo.body',
  'plugins.OnboardingPlugin.chapters.sensors.steps.customSensor.title',
  'plugins.OnboardingPlugin.chapters.sensors.steps.customSensor.body',
  'plugins.OnboardingPlugin.chapters.sensors.steps.multiSensor.title',
  'plugins.OnboardingPlugin.chapters.sensors.steps.multiSensor.body',
  'plugins.OnboardingPlugin.chapters.watchlist.title',
  'plugins.OnboardingPlugin.chapters.watchlist.description',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.pickTarget.title',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.pickTarget.body',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.addToWatchlist.title',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.addToWatchlist.body',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.overlay.title',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.overlay.body',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.lookAngles.title',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.lookAngles.body',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.bestPasses.title',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.bestPasses.body',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.timelines.title',
  'plugins.OnboardingPlugin.chapters.watchlist.steps.timelines.body',
  'plugins.OnboardingPlugin.chapters.time.title',
  'plugins.OnboardingPlugin.chapters.time.description',
  'plugins.OnboardingPlugin.chapters.time.steps.speedUp.title',
  'plugins.OnboardingPlugin.chapters.time.steps.speedUp.body',
  'plugins.OnboardingPlugin.chapters.time.steps.pauseRewind.title',
  'plugins.OnboardingPlugin.chapters.time.steps.pauseRewind.body',
  'plugins.OnboardingPlugin.chapters.time.steps.jumpToMoment.title',
  'plugins.OnboardingPlugin.chapters.time.steps.jumpToMoment.body',
  'plugins.OnboardingPlugin.chapters.time.steps.timeSlider.title',
  'plugins.OnboardingPlugin.chapters.time.steps.timeSlider.body',
  'plugins.OnboardingPlugin.chapters.time.steps.scenarios.title',
  'plugins.OnboardingPlugin.chapters.time.steps.scenarios.body',
  'plugins.OnboardingPlugin.chapters.time.steps.backToNow.title',
  'plugins.OnboardingPlugin.chapters.time.steps.backToNow.body',
  'plugins.OnboardingPlugin.chapters.analysis.title',
  'plugins.OnboardingPlugin.chapters.analysis.description',
  'plugins.OnboardingPlugin.chapters.analysis.steps.advancedSearch.title',
  'plugins.OnboardingPlugin.chapters.analysis.steps.advancedSearch.body',
  'plugins.OnboardingPlugin.chapters.analysis.steps.filterCatalog.title',
  'plugins.OnboardingPlugin.chapters.analysis.steps.filterCatalog.body',
  'plugins.OnboardingPlugin.chapters.analysis.steps.polarPlot.title',
  'plugins.OnboardingPlugin.chapters.analysis.steps.polarPlot.body',
  'plugins.OnboardingPlugin.chapters.analysis.steps.dops.title',
  'plugins.OnboardingPlugin.chapters.analysis.steps.dops.body',
  'plugins.OnboardingPlugin.chapters.analysis.steps.whatIf.title',
  'plugins.OnboardingPlugin.chapters.analysis.steps.whatIf.body',
  'plugins.OnboardingPlugin.chapters.visualization.title',
  'plugins.OnboardingPlugin.chapters.visualization.description',
  'plugins.OnboardingPlugin.chapters.visualization.steps.colorSchemes.title',
  'plugins.OnboardingPlugin.chapters.visualization.steps.colorSchemes.body',
  'plugins.OnboardingPlugin.chapters.visualization.steps.flatMap.title',
  'plugins.OnboardingPlugin.chapters.visualization.steps.flatMap.body',
  'plugins.OnboardingPlugin.chapters.visualization.steps.polarView.title',
  'plugins.OnboardingPlugin.chapters.visualization.steps.polarView.body',
  'plugins.OnboardingPlugin.chapters.visualization.steps.backTo3d.title',
  'plugins.OnboardingPlugin.chapters.visualization.steps.backTo3d.body',
  'plugins.OnboardingPlugin.chapters.visualization.steps.screenshots.title',
  'plugins.OnboardingPlugin.chapters.visualization.steps.screenshots.body',
  'plugins.OnboardingPlugin.chapters.visualization.steps.share.title',
  'plugins.OnboardingPlugin.chapters.visualization.steps.share.body',
  'plugins.OnboardingPlugin.hub.title',
  'plugins.OnboardingPlugin.hub.body',
  'plugins.OnboardingPlugin.hub.progress',
  'plugins.OnboardingPlugin.hub.steps',
  'plugins.OnboardingPlugin.hub.minutes',
  'plugins.OnboardingPlugin.hub.recommended',
  'plugins.OnboardingPlugin.hub.close',
  'plugins.OnboardingPlugin.hub.catalogMissing',
  'plugins.OnboardingPlugin.hub.allDone',
  'plugins.OnboardingPlugin.teasers.signInCta',
  'plugins.OnboardingPlugin.teasers.bestPass.title',
  'plugins.OnboardingPlugin.teasers.bestPass.body',
  'plugins.OnboardingPlugin.teasers.dops.title',
  'plugins.OnboardingPlugin.teasers.dops.body',
  'plugins.OnboardingPlugin.teasers.polarView.title',
  'plugins.OnboardingPlugin.teasers.polarView.body',
  'plugins.OnboardingPlugin.teasers.flatMap.title',
  'plugins.OnboardingPlugin.teasers.flatMap.body',
  'plugins.OnboardingPlugin.stepDone',
  'plugins.OrbitGuardMenuPlugin.bottomIconLabel',
  'plugins.OrbitGuardMenuPlugin.title',
  'plugins.OrbitGuardMenuPlugin.sections.results',
  'plugins.OrbitGuardMenuPlugin.labels.dataCredit',
  'plugins.OrbitGuardMenuPlugin.labels.previous',
  'plugins.OrbitGuardMenuPlugin.labels.next',
  'plugins.OrbitGuardMenuPlugin.labels.pageOf',
  'plugins.OrbitGuardMenuPlugin.table.norad',
  'plugins.OrbitGuardMenuPlugin.table.eventStartTime',
  'plugins.OrbitGuardMenuPlugin.table.eventEndTime',
  'plugins.OrbitGuardMenuPlugin.table.maneuverClass',
  'plugins.OrbitGuardMenuPlugin.table.maneuverProbability',
  'plugins.OrbitGuardMenuPlugin.table.orbitOutOfFamily',
  'plugins.OrbitGuardMenuPlugin.table.stabilityChange',
  'plugins.OrbitGuardMenuPlugin.table.stabilityChangeProbability',
  'plugins.OrbitGuardMenuPlugin.help.overview',
  'plugins.OrbitGuardMenuPlugin.help.imgAlt',
  'plugins.OrbitGuardMenuPlugin.help.imgCaption',
  'plugins.OrbitGuardMenuPlugin.help.howToUse',
  'plugins.OrbitGuardMenuPlugin.help.tip1',
  'plugins.OrbitGuardMenuPlugin.help.tip2',
  'plugins.OrbitReferences.tooltip',
  'plugins.OrbitReferences.linkText',
  'plugins.PlanetsMenuPlugin.bottomIconLabel',
  'plugins.PlanetsMenuPlugin.title',
  'plugins.PlanetsMenuPlugin.sections.planets',
  'plugins.PlanetsMenuPlugin.sections.dwarfPlanets',
  'plugins.PlanetsMenuPlugin.sections.moons',
  'plugins.PlanetsMenuPlugin.sections.otherCelestialBodies',
  'plugins.PlanetsMenuPlugin.sections.star',
  'plugins.PlanetsMenuPlugin.sections.terrestrialPlanets',
  'plugins.PlanetsMenuPlugin.sections.asteroidBelt',
  'plugins.PlanetsMenuPlugin.sections.gasGiants',
  'plugins.PlanetsMenuPlugin.sections.iceGiants',
  'plugins.PlanetsMenuPlugin.sections.transNeptunian',
  'plugins.PlanetsMenuPlugin.bodies.Mercury',
  'plugins.PlanetsMenuPlugin.bodies.Venus',
  'plugins.PlanetsMenuPlugin.bodies.Earth',
  'plugins.PlanetsMenuPlugin.bodies.Mars',
  'plugins.PlanetsMenuPlugin.bodies.Jupiter',
  'plugins.PlanetsMenuPlugin.bodies.Saturn',
  'plugins.PlanetsMenuPlugin.bodies.Uranus',
  'plugins.PlanetsMenuPlugin.bodies.Neptune',
  'plugins.PlanetsMenuPlugin.bodies.Pluto',
  'plugins.PlanetsMenuPlugin.bodies.Makemake',
  'plugins.PlanetsMenuPlugin.bodies.Eris',
  'plugins.PlanetsMenuPlugin.bodies.Haumea',
  'plugins.PlanetsMenuPlugin.bodies.Ceres',
  'plugins.PlanetsMenuPlugin.bodies.Sedna',
  'plugins.PlanetsMenuPlugin.bodies.Quaoar',
  'plugins.PlanetsMenuPlugin.bodies.Orcus',
  'plugins.PlanetsMenuPlugin.bodies.Gonggong',
  'plugins.PlanetsMenuPlugin.bodies.Charon',
  'plugins.PlanetsMenuPlugin.bodies.Moon',
  'plugins.PlanetsMenuPlugin.bodies.Phobos',
  'plugins.PlanetsMenuPlugin.bodies.Deimos',
  'plugins.PlanetsMenuPlugin.bodies.Io',
  'plugins.PlanetsMenuPlugin.bodies.Europa',
  'plugins.PlanetsMenuPlugin.bodies.Ganymede',
  'plugins.PlanetsMenuPlugin.bodies.Callisto',
  'plugins.PlanetsMenuPlugin.bodies.Mimas',
  'plugins.PlanetsMenuPlugin.bodies.Enceladus',
  'plugins.PlanetsMenuPlugin.bodies.Tethys',
  'plugins.PlanetsMenuPlugin.bodies.Dione',
  'plugins.PlanetsMenuPlugin.bodies.Rhea',
  'plugins.PlanetsMenuPlugin.bodies.Titan',
  'plugins.PlanetsMenuPlugin.bodies.Iapetus',
  'plugins.PlanetsMenuPlugin.bodies.Miranda',
  'plugins.PlanetsMenuPlugin.bodies.Ariel',
  'plugins.PlanetsMenuPlugin.bodies.Umbriel',
  'plugins.PlanetsMenuPlugin.bodies.Titania',
  'plugins.PlanetsMenuPlugin.bodies.Oberon',
  'plugins.PlanetsMenuPlugin.bodies.Triton',
  'plugins.PlanetsMenuPlugin.bodies.Sun',
  'plugins.PlanetsMenuPlugin.bodies.Vesta',
  'plugins.PlanetsMenuPlugin.bodies.Pallas',
  'plugins.PlanetsMenuPlugin.bodies.Juno',
  'plugins.PlanetsMenuPlugin.bodies.Hygiea',
  'plugins.PlanetsMenuPlugin.tooltips.centerCamera',
  'plugins.PlanetsMenuPlugin.tooltips.plannedFuture',
  'plugins.PlanetsMenuPlugin.filterPlaceholder',
  'plugins.PlanetsMenuPlugin.commands.toggleMenu',
  'plugins.PlanetsMenuPlugin.commands.centerOn',
  'plugins.PlanetsMenuPlugin.help.overview',
  'plugins.PlanetsMenuPlugin.help.imgAlt',
  'plugins.PlanetsMenuPlugin.help.imgCaption',
  'plugins.PlanetsMenuPlugin.help.howToUse',
  'plugins.PlanetsMenuPlugin.help.tip1',
  'plugins.PlanetsMenuPlugin.help.tip2',
  'plugins.PlanetsMenuPlugin.help.shortcutToggle',
  'plugins.PlanetsMenuPlugin.help.shortcutHome',
  'plugins.PlanetsMenuPlugin.help.shortcutCenterEarth',
  'plugins.Inc2AltPlots.bottomIconLabel',
  'plugins.Inc2AltPlots.title',
  'plugins.Inc2AltPlots.labels.totalLeoPayloads',
  'plugins.Inc2AltPlots.help.overview',
  'plugins.Inc2AltPlots.help.imgAlt',
  'plugins.Inc2AltPlots.help.imgCaption',
  'plugins.Inc2AltPlots.help.howToUse',
  'plugins.Inc2AltPlots.help.tip1',
  'plugins.Inc2AltPlots.help.tip2',
  'plugins.Inc2LonPlots.bottomIconLabel',
  'plugins.Inc2LonPlots.title',
  'plugins.Inc2LonPlots.labels.totalGeoPayloads',
  'plugins.Inc2LonPlots.help.overview',
  'plugins.Inc2LonPlots.help.imgAlt',
  'plugins.Inc2LonPlots.help.imgCaption',
  'plugins.Inc2LonPlots.help.howToUse',
  'plugins.Inc2LonPlots.help.tip1',
  'plugins.Inc2LonPlots.help.tip2',
  'plugins.Inc2LonPlots.help.shortcutToggle',
  'plugins.Time2LonPlots.bottomIconLabel',
  'plugins.Time2LonPlots.title',
  'plugins.Time2LonPlots.labels.statistics',
  'plugins.Time2LonPlots.labels.objectsShown',
  'plugins.Time2LonPlots.labels.unitMin',
  'plugins.Time2LonPlots.chart.title',
  'plugins.Time2LonPlots.chart.xAxis',
  'plugins.Time2LonPlots.chart.yAxis',
  'plugins.Time2LonPlots.chart.tooltipCountry',
  'plugins.Time2LonPlots.chart.tooltipLongitude',
  'plugins.Time2LonPlots.chart.tooltipTime',
  'plugins.Time2LonPlots.chart.loading',
  'plugins.Time2LonPlots.chart.empty',
  'plugins.Time2LonPlots.help.overview',
  'plugins.Time2LonPlots.help.imgAlt',
  'plugins.Time2LonPlots.help.imgCaption',
  'plugins.Time2LonPlots.help.howToUse',
  'plugins.Time2LonPlots.help.tip1',
  'plugins.Time2LonPlots.help.tip2',
  'plugins.Lat2LonPlots.bottomIconLabel',
  'plugins.Lat2LonPlots.title',
  'plugins.Lat2LonPlots.help.overview',
  'plugins.Lat2LonPlots.help.howToUse',
  'plugins.Lat2LonPlots.help.tip1',
  'plugins.EciPlot.bottomIconLabel',
  'plugins.EciPlot.title',
  'plugins.EciPlot.help.overview',
  'plugins.EciPlot.help.howToUse',
  'plugins.EciPlot.help.tip1',
  'plugins.EcfPlot.bottomIconLabel',
  'plugins.EcfPlot.title',
  'plugins.EcfPlot.help.overview',
  'plugins.EcfPlot.help.howToUse',
  'plugins.EcfPlot.help.tip1',
  'plugins.RicPlot.bottomIconLabel',
  'plugins.RicPlot.title',
  'plugins.RicPlot.orbitsLabel',
  'plugins.RicPlot.labels.primary',
  'plugins.RicPlot.labels.secondary',
  'plugins.RicPlot.assessment.title',
  'plugins.RicPlot.assessment.plane',
  'plugins.RicPlot.assessment.closelySpaced',
  'plugins.RicPlot.assessment.coOrbital',
  'plugins.RicPlot.assessment.coPlanar',
  'plugins.RicPlot.assessment.unrelated',
  'plugins.RicPlot.assessment.unknown',
  'plugins.RicPlot.chart.radial',
  'plugins.RicPlot.chart.inTrack',
  'plugins.RicPlot.chart.crossTrack',
  'plugins.RicPlot.chart.range',
  'plugins.RicPlot.chart.timeAxis',
  'plugins.RicPlot.chart.distanceAxis',
  'plugins.RicPlot.chart.empty',
  'plugins.RicPlot.chart.unitKm',
  'plugins.RicPlot.chart.unitMin',
  'plugins.RicPlot.help.overview',
  'plugins.RicPlot.help.howToUse',
  'plugins.RicPlot.help.tip1',
  'plugins.PluginManagerPlugin.bottomIconLabel',
  'plugins.PluginManagerPlugin.title',
  'plugins.PluginManagerPlugin.helpBody',
  'plugins.PluginManagerPlugin.commandPalette.open',
  'plugins.PluginManagerPlugin.tabs.installed',
  'plugins.PluginManagerPlugin.tabs.browse',
  'plugins.PluginManagerPlugin.tabs.develop',
  'plugins.PluginManagerPlugin.browse.loading',
  'plugins.PluginManagerPlugin.browse.empty',
  'plugins.PluginManagerPlugin.browse.error',
  'plugins.PluginManagerPlugin.browse.by',
  'plugins.PluginManagerPlugin.browse.install',
  'plugins.PluginManagerPlugin.browse.installing',
  'plugins.PluginManagerPlugin.browse.installed',
  'plugins.PluginManagerPlugin.browse.installedBtn',
  'plugins.PluginManagerPlugin.browse.installFailed',
  'plugins.PluginManagerPlugin.browse.copyCommand',
  'plugins.PluginManagerPlugin.develop.introHeading',
  'plugins.PluginManagerPlugin.develop.intro',
  'plugins.PluginManagerPlugin.develop.createHeading',
  'plugins.PluginManagerPlugin.develop.create',
  'plugins.PluginManagerPlugin.develop.previewHeading',
  'plugins.PluginManagerPlugin.develop.preview',
  'plugins.PluginManagerPlugin.develop.rulesHeading',
  'plugins.PluginManagerPlugin.develop.rule1',
  'plugins.PluginManagerPlugin.develop.rule2',
  'plugins.PluginManagerPlugin.develop.docsLink',
  'plugins.PluginManagerPlugin.reload.pending',
  'plugins.PluginManagerPlugin.reload.button',
  'plugins.PluginManagerPlugin.labels.search',
  'plugins.PluginManagerPlugin.labels.builtInSection',
  'plugins.PluginManagerPlugin.labels.externalSection',
  'plugins.PluginManagerPlugin.labels.externalEmpty',
  'plugins.PluginManagerPlugin.labels.installSection',
  'plugins.PluginManagerPlugin.labels.installHint',
  'plugins.PluginManagerPlugin.labels.gitUrl',
  'plugins.PluginManagerPlugin.labels.source',
  'plugins.PluginManagerPlugin.badge.compatible',
  'plugins.PluginManagerPlugin.badge.incompatible',
  'plugins.PluginManagerPlugin.buttons.copyInstall',
  'plugins.PluginManagerPlugin.toasts.installCopied',
  'plugins.PluginManagerPlugin.toasts.commandCopied',
  'plugins.PluginManagerPlugin.help.overview',
  'plugins.PluginManagerPlugin.help.togglesHeading',
  'plugins.PluginManagerPlugin.help.toggles',
  'plugins.PluginManagerPlugin.help.externalHeading',
  'plugins.PluginManagerPlugin.help.external',
  'plugins.PolarPlotPlugin.bottomIconLabel',
  'plugins.PolarPlotPlugin.title',
  'plugins.PolarPlotPlugin.labels.notInView',
  'plugins.PolarPlotPlugin.labels.saveImage',
  'plugins.PolarPlotPlugin.labels.satellite',
  'plugins.PolarPlotPlugin.labels.unknownSensor',
  'plugins.PolarPlotPlugin.labels.unknownStartTime',
  'plugins.PolarPlotPlugin.labels.unknownStopTime',
  'plugins.PolarPlotPlugin.labels.prevPass',
  'plugins.PolarPlotPlugin.labels.nextPass',
  'plugins.PolarPlotPlugin.labels.imageSize',
  'plugins.PolarPlotPlugin.labels.size_square',
  'plugins.PolarPlotPlugin.labels.size_wide',
  'plugins.PolarPlotPlugin.labels.size_large',
  'plugins.PolarPlotPlugin.labels.copyImage',
  'plugins.PolarPlotPlugin.labels.copied',
  'plugins.PolarPlotPlugin.labels.passLabel',
  'plugins.PolarPlotPlugin.labels.maxEl',
  'plugins.PolarPlotPlugin.sections.pass',
  'plugins.PolarPlotPlugin.sections.export',
  'plugins.PolarPlotPlugin.errorMsgs.copyFailed',
  'plugins.PolarPlotPlugin.help.overview',
  'plugins.PolarPlotPlugin.help.imgAlt',
  'plugins.PolarPlotPlugin.help.imgCaption',
  'plugins.PolarPlotPlugin.help.readingHeading',
  'plugins.PolarPlotPlugin.help.reading',
  'plugins.PolarPlotPlugin.help.howToUse',
  'plugins.PolarPlotPlugin.help.tip1',
  'plugins.PolarPlotPlugin.help.tip2',
  'plugins.PolarPlotPlugin.help.shortcutToggle',
  'plugins.PoliticalMapToggle.bottomIconLabel',
  'plugins.PoliticalMapToggle.modeOff',
  'plugins.PoliticalMapToggle.modeBorders',
  'plugins.PoliticalMapToggle.modeBordersLabels',
  'plugins.PoliticalMapToggle.modeLabels',
  'plugins.PoliticalMapToggle.commandPalette.cycle',
  'plugins.PoliticalMapToggle.commandPalette.toggle',
  'plugins.PoliticalMapToggle.commandPalette.toggleLabels',
  'plugins.ProximityOps.bottomIconLabel',
  'plugins.ProximityOps.title',
  'plugins.ProximityOps.titleSecondary',
  'plugins.ProximityOps.noradId',
  'plugins.ProximityOps.useCurrentSat',
  'plugins.ProximityOps.noSatSelected',
  'plugins.ProximityOps.maxDistThreshold',
  'plugins.ProximityOps.maxRelativeVelocity',
  'plugins.ProximityOps.searchDuration',
  'plugins.ProximityOps.geoText',
  'plugins.ProximityOps.leoText',
  'plugins.ProximityOps.orbitType',
  'plugins.ProximityOps.geoAllVsAll',
  'plugins.ProximityOps.geoAllVsAllTooltip',
  'plugins.ProximityOps.comparePayloadsOnly',
  'plugins.ProximityOps.comparePayloadsOnlyTooltip',
  'plugins.ProximityOps.ignoreVimpelRso',
  'plugins.ProximityOps.ignoreVimpelRsoTooltip',
  'plugins.ProximityOps.submitButton',
  'plugins.ProximityOps.cancelButton',
  'plugins.ProximityOps.resultCount',
  'plugins.ProximityOps.surveyError',
  'plugins.ProximityOps.sections.target',
  'plugins.ProximityOps.sections.thresholds',
  'plugins.ProximityOps.sections.orbitRegime',
  'plugins.ProximityOps.noRposToDownload',
  'plugins.ProximityOps.noRposFound',
  'plugins.ProximityOps.satNotFound',
  'plugins.ProximityOps.geoOrbitsEcf',
  'plugins.ProximityOps.geoOrbitsEci',
  'plugins.ProximityOps.vimpelNotSupported',
  'plugins.ProximityOps.table.target',
  'plugins.ProximityOps.table.targetName',
  'plugins.ProximityOps.table.chaser',
  'plugins.ProximityOps.table.chaserName',
  'plugins.ProximityOps.table.relDistance',
  'plugins.ProximityOps.table.relVelocity',
  'plugins.ProximityOps.table.radial',
  'plugins.ProximityOps.table.intrack',
  'plugins.ProximityOps.table.crosstrack',
  'plugins.ProximityOps.table.pc',
  'plugins.ProximityOps.table.date',
  'plugins.ProximityOps.help.overview',
  'plugins.ProximityOps.help.imgAlt',
  'plugins.ProximityOps.help.imgCaption',
  'plugins.ProximityOps.help.modesHeading',
  'plugins.ProximityOps.help.modes',
  'plugins.ProximityOps.help.resultsHeading',
  'plugins.ProximityOps.help.results',
  'plugins.ProximityOps.help.howToUse',
  'plugins.ProximityOps.help.tip1',
  'plugins.ProximityOps.help.tip2',
  'plugins.ProximityOps.help.tip3',
  'plugins.ProximityOps.help.shortcutToggle',
  'plugins.Reentries.bottomIconLabel',
  'plugins.Reentries.title',
  'plugins.Reentries.tabLabels.tipMessages',
  'plugins.Reentries.tabLabels.reentryAnalysis',
  'plugins.Reentries.toolbar.fetchData',
  'plugins.Reentries.toolbar.refresh',
  'plugins.Reentries.toolbar.flyToCorridor',
  'plugins.Reentries.toolbar.flyToCorridorTooltip',
  'plugins.Reentries.table.norad',
  'plugins.Reentries.table.decayDate',
  'plugins.Reentries.table.latitude',
  'plugins.Reentries.table.longitude',
  'plugins.Reentries.table.window',
  'plugins.Reentries.table.nextReport',
  'plugins.Reentries.table.reentryAngle',
  'plugins.Reentries.table.rcs',
  'plugins.Reentries.table.gpAge',
  'plugins.Reentries.table.dryMass',
  'plugins.Reentries.table.volume',
  'plugins.Reentries.table.name',
  'plugins.Reentries.table.type',
  'plugins.Reentries.table.perigee',
  'plugins.Reentries.table.apogee',
  'plugins.Reentries.table.meanAlt',
  'plugins.Reentries.table.incl',
  'plugins.Reentries.table.rcsSup',
  'plugins.Reentries.labels.reentered',
  'plugins.Reentries.labels.payload',
  'plugins.Reentries.labels.rocketBody',
  'plugins.Reentries.labels.debris',
  'plugins.Reentries.labels.dataActions',
  'plugins.Reentries.labels.results',
  'plugins.Reentries.help.overview',
  'plugins.Reentries.help.imgAlt',
  'plugins.Reentries.help.imgCaption',
  'plugins.Reentries.help.tabsHeading',
  'plugins.Reentries.help.tabs',
  'plugins.Reentries.help.howToUse',
  'plugins.Reentries.help.tip1',
  'plugins.Reentries.help.tip2',
  'plugins.Reentries.help.tip3',
  'plugins.Reentries.help.shortcutToggle',
  'plugins.Reentries.dataSource',
  'plugins.Reentries.errorMsgs.noTipData',
  'plugins.Reentries.errorMsgs.errorFetching',
  'plugins.Reentries.errorMsgs.errorProcessing',
  'plugins.Reentries.errorMsgs.satelliteDecayed',
  'plugins.ReportsPlugin.bottomIconLabel',
  'plugins.ReportsPlugin.title',
  'plugins.ReportsPlugin.reports.aer.name',
  'plugins.ReportsPlugin.reports.aer.description',
  'plugins.ReportsPlugin.reports.lla.name',
  'plugins.ReportsPlugin.reports.lla.description',
  'plugins.ReportsPlugin.reports.eci.name',
  'plugins.ReportsPlugin.reports.eci.description',
  'plugins.ReportsPlugin.reports.coes.name',
  'plugins.ReportsPlugin.reports.coes.description',
  'plugins.ReportsPlugin.reports.visibilityWindows.name',
  'plugins.ReportsPlugin.reports.visibilityWindows.description',
  'plugins.ReportsPlugin.reports.sunEclipse.name',
  'plugins.ReportsPlugin.reports.sunEclipse.description',
  'plugins.ReportsPlugin.commands.generateReport',
  'plugins.ReportsPlugin.commands.open',
  'plugins.ReportsPlugin.downloadButton',
  'plugins.ReportsPlugin.copyButton',
  'plugins.ReportsPlugin.sensorNote',
  'plugins.ReportsPlugin.sections.orbitPosition',
  'plugins.ReportsPlugin.sections.sensor',
  'plugins.ReportsPlugin.sections.options',
  'plugins.ReportsPlugin.options.window',
  'plugins.ReportsPlugin.options.step',
  'plugins.ReportsPlugin.options.format',
  'plugins.ReportsPlugin.options.days',
  'plugins.ReportsPlugin.options.seconds',
  'plugins.ReportsPlugin.options.format_text',
  'plugins.ReportsPlugin.options.format_csv',
  'plugins.ReportsPlugin.options.format_json',
  'plugins.ReportsPlugin.help.overview',
  'plugins.ReportsPlugin.help.imgAlt',
  'plugins.ReportsPlugin.help.imgCaption',
  'plugins.ReportsPlugin.help.typesHeading',
  'plugins.ReportsPlugin.help.types',
  'plugins.ReportsPlugin.help.howToUse',
  'plugins.ReportsPlugin.help.tip1',
  'plugins.ReportsPlugin.help.tip2',
  'plugins.ReportsPlugin.errorMsgs.notSupportedForObject',
  'plugins.SatConstellations.bottomIconLabel',
  'plugins.SatConstellations.title',
  'plugins.SatConstellations.help.overview',
  'plugins.SatConstellations.help.imgAlt',
  'plugins.SatConstellations.help.imgCaption',
  'plugins.SatConstellations.help.readingHeading',
  'plugins.SatConstellations.help.reading',
  'plugins.SatConstellations.help.filtersHeading',
  'plugins.SatConstellations.help.filters',
  'plugins.SatConstellations.help.howToUse',
  'plugins.SatConstellations.help.tip1',
  'plugins.SatConstellations.help.tip2',
  'plugins.SatConstellations.help.tip3',
  'plugins.SatConstellations.constellations.SpaceStations',
  'plugins.SatConstellations.constellations.AmateurRadio',
  'plugins.SatConstellations.constellations.GPSGroup',
  'plugins.SatConstellations.constellations.GalileoGroup',
  'plugins.SatConstellations.constellations.GlonassGroup',
  'plugins.SatConstellations.constellations.iridium',
  'plugins.SatConstellations.constellations.orbcomm',
  'plugins.SatConstellations.constellations.globalstar',
  'plugins.SatConstellations.constellations.ses',
  'plugins.SatConstellations.constellations.aehf',
  'plugins.SatConstellations.constellations.wgs',
  'plugins.SatConstellations.constellations.starlink',
  'plugins.SatConstellations.constellations.sbirs',
  'plugins.SatConstellations.constellations.starlink-gen2',
  'plugins.SatConstellations.constellations.starlink-v2',
  'plugins.SatConstellations.constellations.starlink-snapshot',
  'plugins.SatConstellations.constellations.starshield',
  'plugins.SatConstellations.constellations.pwsa',
  'plugins.SatConstellations.constellations.kuiper',
  'plugins.SatConstellations.constellations.ast-spaceobile',
  'plugins.SatConstellations.constellations.oneweb',
  'plugins.SatConstellations.constellations.telesat-lightspeed',
  'plugins.SatConstellations.constellations.boeing',
  'plugins.SatConstellations.constellations.astra',
  'plugins.SatConstellations.constellations.spinlaunch',
  'plugins.SatConstellations.constellations.hvnet',
  'plugins.SatConstellations.constellations.lynk',
  'plugins.SatConstellations.constellations.guanwang',
  'plugins.SatConstellations.constellations.qianfan',
  'plugins.SatConstellations.constellations.honghu3',
  'plugins.SatConstellations.constellations.yinhe',
  'plugins.SatConstellations.constellations.hanwha',
  'plugins.SatConstellations.sections.constellations',
  'plugins.SatConstellations.sections.statistics',
  'plugins.SatConstellations.sections.results',
  'plugins.SatConstellations.sections.filters',
  'plugins.SatConstellations.stats.satellites',
  'plugins.SatConstellations.stats.avgAltitude',
  'plugins.SatConstellations.stats.incRange',
  'plugins.SatConstellations.table.norad',
  'plugins.SatConstellations.table.name',
  'plugins.SatConstellations.table.inclination',
  'plugins.SatConstellations.table.raan',
  'plugins.SatConstellations.table.perigee',
  'plugins.SatConstellations.table.apogee',
  'plugins.SatConstellations.filters.incMin',
  'plugins.SatConstellations.filters.incMax',
  'plugins.SatConstellations.filters.altMin',
  'plugins.SatConstellations.filters.altMax',
  'plugins.SatConstellations.filters.raanMin',
  'plugins.SatConstellations.filters.raanMax',
  'plugins.SatConstellations.filters.nameFilter',
  'plugins.SatConstellations.filters.apply',
  'plugins.SatConstellations.filters.reset',
  'plugins.SatConstellations.commands.category',
  'plugins.SatConstellations.errorMsgs.NoConstellationSelected',
  'plugins.SatConstellations.errorMsgs.ConstellationEmpty',
  'plugins.SatInfoBoxSensor.sectionTitle',
  'plugins.SatInfoBoxSensor.labels.range',
  'plugins.SatInfoBoxSensor.labels.azimuth',
  'plugins.SatInfoBoxSensor.labels.elevation',
  'plugins.SatInfoBoxSensor.labels.ra',
  'plugins.SatInfoBoxSensor.labels.dec',
  'plugins.SatInfoBoxSensor.labels.beamWidth',
  'plugins.SatInfoBoxSensor.labels.maxTmxTime',
  'plugins.SatInfoBoxSensor.labels.sun',
  'plugins.SatInfoBoxSensor.labels.visMag',
  'plugins.SatInfoBoxSensor.labels.nextPass',
  'plugins.SatInfoBoxSensor.tooltips.range',
  'plugins.SatInfoBoxSensor.tooltips.azimuth',
  'plugins.SatInfoBoxSensor.tooltips.elevation',
  'plugins.SatInfoBoxSensor.tooltips.ra',
  'plugins.SatInfoBoxSensor.tooltips.dec',
  'plugins.SatInfoBoxSensor.tooltips.beamWidth',
  'plugins.SatInfoBoxSensor.tooltips.maxTmxTime',
  'plugins.SatInfoBoxSensor.tooltips.sun',
  'plugins.SatInfoBoxSensor.tooltips.visMag',
  'plugins.SatInfoBoxSensor.tooltips.nextPass',
  'plugins.SatInfoBoxSensor.values.noEffect',
  'plugins.SatInfoBoxSensor.values.sunExclusion',
  'plugins.SatInfoBoxSensor.values.noSunlight',
  'plugins.SatInfoBoxSensor.values.limitedSunlight',
  'plugins.SatInfoBoxSensor.values.directSunlight',
  'plugins.SatInfoBoxSensor.values.unableToCalculate',
  'plugins.SatInfoBoxSensor.values.outOfFov',
  'plugins.SatInfoBoxSensor.values.unavailable',
  'plugins.SatInfoBoxSensor.values.beyondMaxRange',
  'plugins.SatelliteEciView.bottomIconLabel',
  'plugins.SatelliteEciView.commandPalette.activate',
  'plugins.SatelliteFixedView.bottomIconLabel',
  'plugins.SatelliteFov.bottomIconLabel',
  'plugins.SatelliteFov.title',
  'plugins.SatelliteFov.tabs.earthCenter',
  'plugins.SatelliteFov.tabs.satToSat',
  'plugins.SatelliteFov.labels.sensorDesign',
  'plugins.SatelliteFov.labels.colorSettings',
  'plugins.SatelliteFov.labels.defaultSensorDesign',
  'plugins.SatelliteFov.labels.defaultColorSettings',
  'plugins.SatelliteFov.labels.activeSensors',
  'plugins.SatelliteFov.labels.targetSatellite',
  'plugins.SatelliteFov.labels.fovSettings',
  'plugins.SatelliteFov.labels.activeS2sCones',
  'plugins.SatelliteFov.labels.fovDegrees',
  'plugins.SatelliteFov.labels.opacity',
  'plugins.SatelliteFov.labels.targetCatalogNumber',
  'plugins.SatelliteFov.tooltips.fovOfSensor',
  'plugins.SatelliteFov.tooltips.red',
  'plugins.SatelliteFov.tooltips.green',
  'plugins.SatelliteFov.tooltips.blue',
  'plugins.SatelliteFov.tooltips.opacity',
  'plugins.SatelliteFov.buttons.resetAllFovCones',
  'plugins.SatelliteFov.buttons.useSecondarySat',
  'plugins.SatelliteFov.buttons.createS2sCone',
  'plugins.SatelliteFov.buttons.resetS2sCones',
  'plugins.SatelliteFov.errorMsgs.noSecondary',
  'plugins.SatelliteFov.errorMsgs.selectSourceFirst',
  'plugins.SatelliteFov.errorMsgs.enterTargetNumber',
  'plugins.SatelliteFov.errorMsgs.targetNotFound',
  'plugins.SatelliteFov.errorMsgs.targetSameAsSource',
  'plugins.SatelliteFov.errorMsgs.fovRange',
  'plugins.SatelliteFov.errorMsgs.redRange',
  'plugins.SatelliteFov.errorMsgs.greenRange',
  'plugins.SatelliteFov.errorMsgs.blueRange',
  'plugins.SatelliteFov.errorMsgs.opacityRange',
  'plugins.SatelliteFov.help.overview',
  'plugins.SatelliteFov.help.imgAlt',
  'plugins.SatelliteFov.help.imgCaption',
  'plugins.SatelliteFov.help.tabsHeading',
  'plugins.SatelliteFov.help.tabs',
  'plugins.SatelliteFov.help.howToUse',
  'plugins.SatelliteFov.help.tip1',
  'plugins.SatelliteFov.help.tip2',
  'plugins.SatelliteFov.help.shortcutToggleCone',
  'plugins.SatelliteFov.help.shortcutToggleS2s',
  'plugins.SatellitePhotos.bottomIconLabel',
  'plugins.SatellitePhotos.title',
  'plugins.SatellitePhotos.defaultImageTitle',
  'plugins.SatellitePhotos.labels.dscovrUnavailable',
  'plugins.SatellitePhotos.labels.dscovrImage',
  'plugins.SatellitePhotos.labels.dscovrLoading',
  'plugins.SatellitePhotos.labels.refresh',
  'plugins.SatellitePhotos.labels.imageAtUtc',
  'plugins.SatellitePhotos.sections.geostationary',
  'plugins.SatellitePhotos.sections.dscovr',
  'plugins.SatellitePhotos.errorMsgs.FuturePictures',
  'plugins.SatellitePhotos.help.overview',
  'plugins.SatellitePhotos.help.imgAlt',
  'plugins.SatellitePhotos.help.imgCaption',
  'plugins.SatellitePhotos.help.howToUse',
  'plugins.SatellitePhotos.help.tip1',
  'plugins.SatellitePhotos.help.tip2',
  'plugins.SatellitePhotos.help.shortcutToggle',
  'plugins.ScenarioManagementMenu.title',
  'plugins.ScenarioManagementMenu.bottomIconLabel',
  'plugins.ScenarioManagementMenu.sideMenuTitle',
  'plugins.ScenarioManagementMenu.sections.actions',
  'plugins.ScenarioManagementMenu.labels.scenarioName',
  'plugins.ScenarioManagementMenu.labels.description',
  'plugins.ScenarioManagementMenu.labels.scenarioStart',
  'plugins.ScenarioManagementMenu.labels.scenarioEnd',
  'plugins.ScenarioManagementMenu.tooltips.name',
  'plugins.ScenarioManagementMenu.tooltips.description',
  'plugins.ScenarioManagementMenu.tooltips.startDate',
  'plugins.ScenarioManagementMenu.tooltips.endDate',
  'plugins.ScenarioManagementMenu.placeholders.description',
  'plugins.ScenarioManagementMenu.buttons.updateScenario',
  'plugins.ScenarioManagementMenu.buttons.saveScenario',
  'plugins.ScenarioManagementMenu.buttons.loadScenario',
  'plugins.ScenarioManagementMenu.buttons.clearTimeBounds',
  'plugins.ScenarioManagementMenu.msgs.settingsUpdated',
  'plugins.ScenarioManagementMenu.msgs.scenarioLoaded',
  'plugins.ScenarioManagementMenu.msgs.boundsCleared',
  'plugins.ScenarioManagementMenu.errorMsgs.nameRequired',
  'plugins.ScenarioManagementMenu.errorMsgs.startDateInvalid',
  'plugins.ScenarioManagementMenu.errorMsgs.endDateInvalid',
  'plugins.ScenarioManagementMenu.errorMsgs.savingScenario',
  'plugins.ScenarioManagementMenu.errorMsgs.loadingScenarioFile',
  'plugins.ScenarioManagementMenu.errorMsgs.decompressingScenarioFile',
  'plugins.ScenarioManagementMenu.defaults.scenarioName',
  'plugins.ScenarioManagementMenu.defaults.scenarioDescription',
  'plugins.ScenarioManagementMenu.core.beforeStartTime',
  'plugins.ScenarioManagementMenu.core.afterStopTime',
  'plugins.ScenarioManagementMenu.help.overview',
  'plugins.ScenarioManagementMenu.help.imgAlt',
  'plugins.ScenarioManagementMenu.help.imgCaption',
  'plugins.ScenarioManagementMenu.help.windowHeading',
  'plugins.ScenarioManagementMenu.help.window',
  'plugins.ScenarioManagementMenu.help.howToUse',
  'plugins.ScenarioManagementMenu.help.tip1',
  'plugins.ScenarioManagementMenu.help.tip2',
  'plugins.ScenarioManagementMenu.help.tip3',
  'plugins.SearchSettingsPlugin.bottomIconLabel',
  'plugins.SearchSettingsPlugin.title',
  'plugins.SearchSettingsPlugin.sections.resultLimits',
  'plugins.SearchSettingsPlugin.sections.objectTypes',
  'plugins.SearchSettingsPlugin.sections.searchFields',
  'plugins.SearchSettingsPlugin.sections.filters',
  'plugins.SearchSettingsPlugin.sections.actions',
  'plugins.SearchSettingsPlugin.labels.maxResults',
  'plugins.SearchSettingsPlugin.labels.minSearchChars',
  'plugins.SearchSettingsPlugin.labels.showDecayed',
  'plugins.SearchSettingsPlugin.labels.showVimpel',
  'plugins.SearchSettingsPlugin.labels.reset',
  'plugins.SearchSettingsPlugin.labels.fields.name',
  'plugins.SearchSettingsPlugin.labels.fields.altName',
  'plugins.SearchSettingsPlugin.labels.fields.bus',
  'plugins.SearchSettingsPlugin.labels.fields.noradId',
  'plugins.SearchSettingsPlugin.labels.fields.intlDes',
  'plugins.SearchSettingsPlugin.labels.fields.launchVehicle',
  'plugins.SearchSettingsPlugin.labels.types.satellite',
  'plugins.SearchSettingsPlugin.labels.types.missile',
  'plugins.SearchSettingsPlugin.labels.types.star',
  'plugins.SearchSettingsPlugin.labels.types.sensor',
  'plugins.SearchSettingsPlugin.labels.types.launchSite',
  'plugins.SearchSettingsPlugin.labels.types.planet',
  'plugins.SearchSettingsPlugin.tooltips.maxResults',
  'plugins.SearchSettingsPlugin.tooltips.minSearchChars',
  'plugins.SearchSettingsPlugin.tooltips.showDecayed',
  'plugins.SearchSettingsPlugin.tooltips.showVimpel',
  'plugins.SearchSettingsPlugin.toasts.reset',
  'plugins.SearchSettingsPlugin.errorMsgs.InvalidMaxResults',
  'plugins.SearchSettingsPlugin.errorMsgs.InvalidMinSearchChars',
  'plugins.SelectSatManager.sectionLabel',
  'plugins.SelectSatManager.settings.focusOnSatWhenSelected.label',
  'plugins.SelectSatManager.settings.focusOnSatWhenSelected.helpText',
  'plugins.SensorInfoPlugin.bottomIconLabel',
  'plugins.SensorInfoPlugin.title',
  'plugins.SensorInfoPlugin.labels.sensorName',
  'plugins.SensorInfoPlugin.labels.country',
  'plugins.SensorInfoPlugin.labels.sensorType',
  'plugins.SensorInfoPlugin.labels.latitude',
  'plugins.SensorInfoPlugin.labels.longitude',
  'plugins.SensorInfoPlugin.labels.minAzimuth',
  'plugins.SensorInfoPlugin.labels.maxAzimuth',
  'plugins.SensorInfoPlugin.labels.minElevation',
  'plugins.SensorInfoPlugin.labels.maxElevation',
  'plugins.SensorInfoPlugin.labels.minRange',
  'plugins.SensorInfoPlugin.labels.maxRange',
  'plugins.SensorInfoPlugin.labels.band',
  'plugins.SensorInfoPlugin.labels.beamWidth',
  'plugins.SensorInfoPlugin.labels.unknown',
  'plugins.SensorInfoPlugin.labels.details',
  'plugins.SensorInfoPlugin.labels.visualizations',
  'plugins.SensorInfoPlugin.buttons.drawLineToSun',
  'plugins.SensorInfoPlugin.buttons.drawLineToMoon',
  'plugins.SensorInfoPlugin.buttons.addLineToSun',
  'plugins.SensorInfoPlugin.buttons.removeLineToSun',
  'plugins.SensorInfoPlugin.buttons.addLineToMoon',
  'plugins.SensorInfoPlugin.buttons.removeLineToMoon',
  'plugins.SensorInfoPlugin.errorMsgs.selectOnlyOneSensor',
  'plugins.SensorInfoPlugin.help.overview',
  'plugins.SensorInfoPlugin.help.imgAlt',
  'plugins.SensorInfoPlugin.help.imgCaption',
  'plugins.SensorInfoPlugin.help.fieldsHeading',
  'plugins.SensorInfoPlugin.help.fields',
  'plugins.SensorInfoPlugin.help.howToUse',
  'plugins.SensorInfoPlugin.help.tip1',
  'plugins.SensorInfoPlugin.help.tip2',
  'plugins.SensorInfoPlugin.help.tip3',
  'plugins.CustomSensorPlugin.bottomIconLabel',
  'plugins.CustomSensorPlugin.title',
  'plugins.CustomSensorPlugin.help.overview',
  'plugins.CustomSensorPlugin.help.imgAlt',
  'plugins.CustomSensorPlugin.help.imgCaption',
  'plugins.CustomSensorPlugin.help.fieldsHeading',
  'plugins.CustomSensorPlugin.help.fields',
  'plugins.CustomSensorPlugin.help.howToUse',
  'plugins.CustomSensorPlugin.help.tip1',
  'plugins.CustomSensorPlugin.help.tip2',
  'plugins.CustomSensorPlugin.labels.sensorName',
  'plugins.CustomSensorPlugin.labels.defaultSensorName',
  'plugins.CustomSensorPlugin.labels.latitude',
  'plugins.CustomSensorPlugin.labels.longitude',
  'plugins.CustomSensorPlugin.labels.elevation',
  'plugins.CustomSensorPlugin.labels.sensorType',
  'plugins.CustomSensorPlugin.labels.typeObserver',
  'plugins.CustomSensorPlugin.labels.typeOptical',
  'plugins.CustomSensorPlugin.labels.typePhasedArray',
  'plugins.CustomSensorPlugin.labels.typeMechanical',
  'plugins.CustomSensorPlugin.labels.telescope',
  'plugins.CustomSensorPlugin.labels.minAzimuth',
  'plugins.CustomSensorPlugin.labels.maxAzimuth',
  'plugins.CustomSensorPlugin.labels.minElevation',
  'plugins.CustomSensorPlugin.labels.maxElevation',
  'plugins.CustomSensorPlugin.labels.minRange',
  'plugins.CustomSensorPlugin.labels.maxRange',
  'plugins.CustomSensorPlugin.labels.replaceSensor',
  'plugins.CustomSensorPlugin.labels.addCustomSensor',
  'plugins.CustomSensorPlugin.labels.clearCustomSensors',
  'plugins.CustomSensorPlugin.labels.useGeolocation',
  'plugins.CustomSensorPlugin.labels.tooltipSensorName',
  'plugins.CustomSensorPlugin.labels.tooltipLatitude',
  'plugins.CustomSensorPlugin.labels.tooltipLongitude',
  'plugins.CustomSensorPlugin.labels.tooltipElevation',
  'plugins.CustomSensorPlugin.labels.tooltipTelescope',
  'plugins.CustomSensorPlugin.labels.tooltipMinAz',
  'plugins.CustomSensorPlugin.labels.tooltipMaxAz',
  'plugins.CustomSensorPlugin.labels.tooltipMinEl',
  'plugins.CustomSensorPlugin.labels.tooltipMaxEl',
  'plugins.CustomSensorPlugin.labels.tooltipMinRange',
  'plugins.CustomSensorPlugin.labels.tooltipMaxRange',
  'plugins.CustomSensorPlugin.rmbMenu.title',
  'plugins.CustomSensorPlugin.rmbMenu.createObserver',
  'plugins.CustomSensorPlugin.rmbMenu.createSensor',
  'plugins.CustomSensorPlugin.sensorList.sensorName',
  'plugins.CustomSensorPlugin.sensorList.latitude',
  'plugins.CustomSensorPlugin.sensorList.longitude',
  'plugins.CustomSensorPlugin.sensorList.elevation',
  'plugins.CustomSensorPlugin.sensorList.azimuth',
  'plugins.CustomSensorPlugin.sensorList.elevationRange',
  'plugins.CustomSensorPlugin.sensorList.range',
  'plugins.CustomSensorPlugin.sensorList.altitude',
  'plugins.CustomSensorPlugin.sensorList.activeSensors',
  'plugins.CustomSensorPlugin.sensorList.empty',
  'plugins.CustomSensorPlugin.sensorList.remove',
  'plugins.CustomSensorPlugin.errorMsgs.latRange',
  'plugins.CustomSensorPlugin.errorMsgs.lonRange',
  'plugins.CustomSensorPlugin.errorMsgs.altRange',
  'plugins.CustomSensorPlugin.errorMsgs.minAzRange',
  'plugins.CustomSensorPlugin.errorMsgs.maxAzRange',
  'plugins.CustomSensorPlugin.errorMsgs.minElRange',
  'plugins.CustomSensorPlugin.errorMsgs.maxElRange',
  'plugins.CustomSensorPlugin.errorMsgs.minRangeValue',
  'plugins.CustomSensorPlugin.errorMsgs.maxRangeValue',
  'plugins.CustomSensorPlugin.errorMsgs.invalidNumber',
  'plugins.CustomSensorPlugin.errorMsgs.elOrder',
  'plugins.CustomSensorPlugin.errorMsgs.rangeOrder',
  'plugins.CustomSensorPlugin.sections.identity',
  'plugins.CustomSensorPlugin.sections.location',
  'plugins.CustomSensorPlugin.sections.fieldOfView',
  'plugins.LookAnglesPlugin.bottomIconLabel',
  'plugins.LookAnglesPlugin.title',
  'plugins.LookAnglesPlugin.sections.results',
  'plugins.LookAnglesPlugin.sections.settings',
  'plugins.LookAnglesPlugin.settings.showRiseSetOnly',
  'plugins.LookAnglesPlugin.settings.calculationLength',
  'plugins.LookAnglesPlugin.settings.interval',
  'plugins.LookAnglesPlugin.table.time',
  'plugins.LookAnglesPlugin.table.type',
  'plugins.LookAnglesPlugin.table.el',
  'plugins.LookAnglesPlugin.table.az',
  'plugins.LookAnglesPlugin.table.rng',
  'plugins.LookAnglesPlugin.table.visible',
  'plugins.LookAnglesPlugin.msgs.notVisible',
  'plugins.LookAnglesPlugin.msgs.yes',
  'plugins.LookAnglesPlugin.msgs.no',
  'plugins.LookAnglesPlugin.msgs.rise',
  'plugins.LookAnglesPlugin.msgs.set',
  'plugins.LookAnglesPlugin.msgs.maxEl',
  'plugins.LookAnglesPlugin.msgs.unknown',
  'plugins.LookAnglesPlugin.help.overview',
  'plugins.LookAnglesPlugin.help.imgAlt',
  'plugins.LookAnglesPlugin.help.imgCaption',
  'plugins.LookAnglesPlugin.help.readingHeading',
  'plugins.LookAnglesPlugin.help.reading',
  'plugins.LookAnglesPlugin.help.howToUse',
  'plugins.LookAnglesPlugin.help.tip1',
  'plugins.LookAnglesPlugin.help.tip2',
  'plugins.MultiSensorLookAnglesPlugin.bottomIconLabel',
  'plugins.MultiSensorLookAnglesPlugin.title',
  'plugins.MultiSensorLookAnglesPlugin.sections.results',
  'plugins.MultiSensorLookAnglesPlugin.sections.sensors',
  'plugins.MultiSensorLookAnglesPlugin.table.time',
  'plugins.MultiSensorLookAnglesPlugin.table.el',
  'plugins.MultiSensorLookAnglesPlugin.table.az',
  'plugins.MultiSensorLookAnglesPlugin.table.rng',
  'plugins.MultiSensorLookAnglesPlugin.table.sensor',
  'plugins.MultiSensorLookAnglesPlugin.table.visible',
  'plugins.MultiSensorLookAnglesPlugin.msgs.notVisible',
  'plugins.MultiSensorLookAnglesPlugin.msgs.yes',
  'plugins.MultiSensorLookAnglesPlugin.msgs.no',
  'plugins.MultiSensorLookAnglesPlugin.msgs.na',
  'plugins.MultiSensorLookAnglesPlugin.help.overview',
  'plugins.MultiSensorLookAnglesPlugin.help.imgAlt',
  'plugins.MultiSensorLookAnglesPlugin.help.imgCaption',
  'plugins.MultiSensorLookAnglesPlugin.help.readingHeading',
  'plugins.MultiSensorLookAnglesPlugin.help.reading',
  'plugins.MultiSensorLookAnglesPlugin.help.howToUse',
  'plugins.MultiSensorLookAnglesPlugin.help.tip1',
  'plugins.MultiSensorLookAnglesPlugin.help.tip2',
  'plugins.SensorListPlugin.bottomIconLabel',
  'plugins.SensorListPlugin.title',
  'plugins.SensorListPlugin.labels.categorySurveillance',
  'plugins.SensorListPlugin.labels.categoryTtc',
  'plugins.SensorListPlugin.labels.missingData',
  'plugins.SensorListPlugin.labels.tooltipSensorsInFov',
  'plugins.SensorListPlugin.buttons.markAll',
  'plugins.SensorListPlugin.buttons.resetSensor',
  'plugins.SensorListPlugin.buttons.showSensorsWithFov',
  'plugins.SensorListPlugin.commands.category',
  'plugins.SensorListPlugin.commands.setSensor',
  'plugins.SensorListPlugin.commands.setSensorGroup',
  'plugins.SensorListPlugin.help.overview',
  'plugins.SensorListPlugin.help.imgAlt',
  'plugins.SensorListPlugin.help.imgCaption',
  'plugins.SensorListPlugin.help.sensorTypesHeading',
  'plugins.SensorListPlugin.help.sensorTypes',
  'plugins.SensorListPlugin.help.howToUse',
  'plugins.SensorListPlugin.help.tip1',
  'plugins.SensorListPlugin.help.tip2',
  'plugins.SensorListPlugin.help.tip3',
  'plugins.SensorListPlugin.help.shortcutToggle',
  'plugins.SensorListPlugin.help.shortcutCamera',
  'plugins.SensorListPlugin.rmbMenu.useThisSensor',
  'plugins.SettingsMenuPlugin.bottomIconLabel',
  'plugins.SettingsMenuPlugin.title',
  'plugins.SettingsMenuPlugin.filterPlaceholder',
  'plugins.SettingsMenuPlugin.buttons.resetToDefaults',
  'plugins.SettingsMenuPlugin.commands.open',
  'plugins.SettingsMenuPlugin.commands.reset',
  'plugins.SettingsMenuPlugin.sections.general',
  'plugins.SettingsMenuPlugin.sections.fastCpu',
  'plugins.SettingsMenuPlugin.labels.showInfoOnHover',
  'plugins.SettingsMenuPlugin.labels.drawOrbits',
  'plugins.SettingsMenuPlugin.labels.drawTrailingOrbits',
  'plugins.SettingsMenuPlugin.labels.drawOrbitsInEcf',
  'plugins.SettingsMenuPlugin.labels.numberOfEcfOrbits',
  'plugins.SettingsMenuPlugin.labels.drawFovLines',
  'plugins.SettingsMenuPlugin.labels.displayEciOnHover',
  'plugins.SettingsMenuPlugin.labels.showCameraWidget',
  'plugins.SettingsMenuPlugin.labels.showConfidenceLevels',
  'plugins.SettingsMenuPlugin.labels.enableDemoMode',
  'plugins.SettingsMenuPlugin.labels.enableFreezeTime',
  'plugins.SettingsMenuPlugin.labels.compensateEarthRotation',
  'plugins.SettingsMenuPlugin.labels.showNextPassOnHover',
  'plugins.SettingsMenuPlugin.tooltips.showInfoOnHover',
  'plugins.SettingsMenuPlugin.tooltips.drawOrbits',
  'plugins.SettingsMenuPlugin.tooltips.drawTrailingOrbits',
  'plugins.SettingsMenuPlugin.tooltips.drawOrbitsInEcf',
  'plugins.SettingsMenuPlugin.tooltips.drawFovLines',
  'plugins.SettingsMenuPlugin.tooltips.displayEciOnHover',
  'plugins.SettingsMenuPlugin.tooltips.showCameraWidget',
  'plugins.SettingsMenuPlugin.tooltips.showConfidenceLevels',
  'plugins.SettingsMenuPlugin.tooltips.enableDemoMode',
  'plugins.SettingsMenuPlugin.tooltips.enableFreezeTime',
  'plugins.SettingsMenuPlugin.tooltips.compensateEarthRotation',
  'plugins.SettingsMenuPlugin.tooltips.showNextPassOnHover',
  'plugins.SettingsMenuPlugin.help.overview',
  'plugins.SettingsMenuPlugin.help.imgAlt',
  'plugins.SettingsMenuPlugin.help.imgCaption',
  'plugins.SettingsMenuPlugin.help.howToUse',
  'plugins.SettingsMenuPlugin.help.tip1',
  'plugins.SettingsMenuPlugin.help.tip2',
  'plugins.ShareMenuPlugin.bottomIconLabel',
  'plugins.ShareMenuPlugin.title',
  'plugins.ShareMenuPlugin.helpBody',
  'plugins.ShareMenuPlugin.commandPalette.share',
  'plugins.ShareMenuPlugin.labels.shareLink',
  'plugins.ShareMenuPlugin.labels.url',
  'plugins.ShareMenuPlugin.buttons.copyLink',
  'plugins.ShareMenuPlugin.buttons.share',
  'plugins.ShareMenuPlugin.toasts.copied',
  'plugins.ShareMenuPlugin.toasts.copyFailed',
  'plugins.ShortTermFences.bottomIconLabel',
  'plugins.ShortTermFences.title',
  'plugins.ShortTermFences.sideMenuTitle',
  'plugins.ShortTermFences.labels.centerAzimuth',
  'plugins.ShortTermFences.labels.azimuthExtentDeg',
  'plugins.ShortTermFences.labels.azimuthExtentKm',
  'plugins.ShortTermFences.labels.centerElevation',
  'plugins.ShortTermFences.labels.elevationExtentDeg',
  'plugins.ShortTermFences.labels.elevationExtentKm',
  'plugins.ShortTermFences.labels.centerRange',
  'plugins.ShortTermFences.labels.rangeExtent',
  'plugins.ShortTermFences.tooltips.centerAzimuth',
  'plugins.ShortTermFences.tooltips.azimuthExtentDeg',
  'plugins.ShortTermFences.tooltips.azimuthExtentKm',
  'plugins.ShortTermFences.tooltips.centerElevation',
  'plugins.ShortTermFences.tooltips.elevationExtentDeg',
  'plugins.ShortTermFences.tooltips.elevationExtentKm',
  'plugins.ShortTermFences.tooltips.centerRange',
  'plugins.ShortTermFences.tooltips.rangeExtent',
  'plugins.ShortTermFences.tooltips.buildOnObject',
  'plugins.ShortTermFences.buttons.createNewStf',
  'plugins.ShortTermFences.buttons.removeLast',
  'plugins.ShortTermFences.buttons.clearAllStfs',
  'plugins.ShortTermFences.links.buildOnObject',
  'plugins.ShortTermFences.errorMsgs.stfNotInView',
  'plugins.ShortTermFences.errorMsgs.noSelectSatManager',
  'plugins.ShortTermFences.errorMsgs.invalidInput',
  'plugins.ShortTermFences.errorMsgs.invalidRange',
  'plugins.ShortTermFences.help.overview',
  'plugins.ShortTermFences.help.imgAlt',
  'plugins.ShortTermFences.help.imgCaption',
  'plugins.ShortTermFences.help.fieldsHeading',
  'plugins.ShortTermFences.help.fields',
  'plugins.ShortTermFences.help.howToUse',
  'plugins.ShortTermFences.help.tip1',
  'plugins.ShortTermFences.help.tip2',
  'plugins.ShortTermFences.sections.azimuth',
  'plugins.ShortTermFences.sections.elevation',
  'plugins.ShortTermFences.sections.range',
  'plugins.ShortTermFences.fenceList.activeFences',
  'plugins.ShortTermFences.fenceList.empty',
  'plugins.ShortTermFences.fenceList.remove',
  'plugins.ShortTermFences.fenceList.azimuth',
  'plugins.ShortTermFences.fenceList.elevation',
  'plugins.ShortTermFences.fenceList.range',
  'plugins.SkipInterpolationToggle.bottomIconLabel',
  'plugins.SkipInterpolationToggle.commandPalette.toggle',
  'plugins.SoundToggle.tooltip',
  'plugins.SoundToggle.errorMsgs.notEnabled',
  'plugins.StereoMap.bottomIconLabel',
  'plugins.StereoMap.title',
  'plugins.StereoMap.help.overview',
  'plugins.StereoMap.help.imgAlt',
  'plugins.StereoMap.help.imgCaption',
  'plugins.StereoMap.help.readingTheMapHeading',
  'plugins.StereoMap.help.readingTheMap',
  'plugins.StereoMap.help.howToUse',
  'plugins.StereoMap.help.tip1',
  'plugins.StereoMap.help.tip2',
  'plugins.StereoMap.help.tip3',
  'plugins.StereoMap.help.shortcutToggle',
  'plugins.StereoMap.commands.toggle',
  'plugins.StereoMap.commands.export',
  'plugins.StereoMap.labels.orbitsToDisplay',
  'plugins.StereoMap.labels.showGraticule',
  'plugins.StereoMap.labels.mapStyle',
  'plugins.StereoMap.labels.standard',
  'plugins.StereoMap.labels.political',
  'plugins.StereoMap.labels.nightLights',
  'plugins.TheSpaceDevLaunchCalendarPlugin.bottomIconLabel',
  'plugins.TheSpaceDevLaunchCalendarPlugin.title',
  'plugins.TheSpaceDevLaunchCalendarPlugin.sideMenuTitle',
  'plugins.TheSpaceDevLaunchCalendarPlugin.tooltips.fetchData',
  'plugins.TheSpaceDevLaunchCalendarPlugin.tooltips.refresh',
  'plugins.TheSpaceDevLaunchCalendarPlugin.tooltips.exportLaunchInfo',
  'plugins.TheSpaceDevLaunchCalendarPlugin.labels.dataActions',
  'plugins.TheSpaceDevLaunchCalendarPlugin.labels.results',
  'plugins.TheSpaceDevLaunchCalendarPlugin.table.launchWindow',
  'plugins.TheSpaceDevLaunchCalendarPlugin.table.mission',
  'plugins.TheSpaceDevLaunchCalendarPlugin.table.location',
  'plugins.TheSpaceDevLaunchCalendarPlugin.table.agency',
  'plugins.TheSpaceDevLaunchCalendarPlugin.table.country',
  'plugins.TheSpaceDevLaunchCalendarPlugin.msgs.fetching',
  'plugins.TheSpaceDevLaunchCalendarPlugin.msgs.unknown',
  'plugins.TheSpaceDevLaunchCalendarPlugin.msgs.tbd',
  'plugins.TheSpaceDevLaunchCalendarPlugin.help.overview',
  'plugins.TheSpaceDevLaunchCalendarPlugin.help.imgAlt',
  'plugins.TheSpaceDevLaunchCalendarPlugin.help.imgCaption',
  'plugins.TheSpaceDevLaunchCalendarPlugin.help.howToUse',
  'plugins.TheSpaceDevLaunchCalendarPlugin.help.tip1',
  'plugins.TheSpaceDevLaunchCalendarPlugin.help.tip2',
  'plugins.TimeSlider.tooltip',
  'plugins.SatelliteTimeline.bottomIconLabel',
  'plugins.SatelliteTimeline.title',
  'plugins.SatelliteTimeline.sections.settings',
  'plugins.SatelliteTimeline.labels.calculationLength',
  'plugins.SatelliteTimeline.labels.calculationInterval',
  'plugins.SatelliteTimeline.labels.badPassLength',
  'plugins.SatelliteTimeline.labels.avgPassLength',
  'plugins.SatelliteTimeline.msgs.noPasses',
  'plugins.SatelliteTimeline.errorMsgs.addSatellitesOrSelect',
  'plugins.SatelliteTimeline.help.overview',
  'plugins.SatelliteTimeline.help.imgAlt',
  'plugins.SatelliteTimeline.help.imgCaption',
  'plugins.SatelliteTimeline.help.readingHeading',
  'plugins.SatelliteTimeline.help.reading',
  'plugins.SatelliteTimeline.help.settingsHeading',
  'plugins.SatelliteTimeline.help.settings',
  'plugins.SatelliteTimeline.help.howToUse',
  'plugins.SatelliteTimeline.help.tip1',
  'plugins.SatelliteTimeline.help.tip2',
  'plugins.SensorTimeline.bottomIconLabel',
  'plugins.SensorTimeline.title',
  'plugins.SensorTimeline.sections.settings',
  'plugins.SensorTimeline.sections.sensors',
  'plugins.SensorTimeline.labels.calculationLength',
  'plugins.SensorTimeline.labels.calculationInterval',
  'plugins.SensorTimeline.labels.badPassLength',
  'plugins.SensorTimeline.labels.avgPassLength',
  'plugins.SensorTimeline.labels.detailedPlot',
  'plugins.SensorTimeline.labels.useWeather',
  'plugins.SensorTimeline.labels.useWeatherTooltip',
  'plugins.SensorTimeline.passTypes.canObserve',
  'plugins.SensorTimeline.passTypes.inFov',
  'plugins.SensorTimeline.passTypes.satInSun',
  'plugins.SensorTimeline.passTypes.stationInNight',
  'plugins.SensorTimeline.passTypes.clearSkies',
  'plugins.SensorTimeline.msgs.observable',
  'plugins.SensorTimeline.msgs.inFov',
  'plugins.SensorTimeline.msgs.atNight',
  'plugins.SensorTimeline.msgs.clearSkies',
  'plugins.SensorTimeline.msgs.noPasses',
  'plugins.SensorTimeline.help.overview',
  'plugins.SensorTimeline.help.imgAlt',
  'plugins.SensorTimeline.help.imgCaption',
  'plugins.SensorTimeline.help.readingHeading',
  'plugins.SensorTimeline.help.reading',
  'plugins.SensorTimeline.help.settingsHeading',
  'plugins.SensorTimeline.help.settings',
  'plugins.SensorTimeline.help.howToUse',
  'plugins.SensorTimeline.help.tip1',
  'plugins.SensorTimeline.help.tip2',
  'plugins.SensorTimeline.help.tip3',
  'plugins.TransponderChannelData.bottomIconLabel',
  'plugins.TransponderChannelData.title',
  'plugins.TransponderChannelData.constellationName',
  'plugins.TransponderChannelData.table.satellite',
  'plugins.TransponderChannelData.table.tvchannel',
  'plugins.TransponderChannelData.table.beam',
  'plugins.TransponderChannelData.table.freq',
  'plugins.TransponderChannelData.table.system',
  'plugins.TransponderChannelData.table.SRFEC',
  'plugins.TransponderChannelData.table.video',
  'plugins.TransponderChannelData.table.lang',
  'plugins.TransponderChannelData.table.encryption',
  'plugins.TransponderChannelData.errorMsgs.NoChannelInfo',
  'plugins.TransponderChannelData.errorMsgs.NotSatellite',
  'plugins.TransponderChannelData.errorMsgs.FetchFailed',
  'plugins.TransponderChannelData.errorMsgs.NoData',
  'plugins.TransponderChannelData.help.overview',
  'plugins.TransponderChannelData.help.imgAlt',
  'plugins.TransponderChannelData.help.imgCaption',
  'plugins.TransponderChannelData.help.columnsHeading',
  'plugins.TransponderChannelData.help.columns',
  'plugins.TransponderChannelData.help.howToUse',
  'plugins.TransponderChannelData.help.tip1',
  'plugins.TransponderChannelData.help.tip2',
  'plugins.TransponderChannelData.help.shortcutToggle',
  'plugins.TransponderChannelData.labels.controls',
  'plugins.TransponderChannelData.labels.channels',
  'plugins.TransponderChannelData.labels.filterPlaceholder',
  'plugins.TransponderChannelData.labels.exportXlsx',
  'plugins.TransponderChannelData.labels.exportCsv',
  'plugins.TransponderChannelData.labels.statusLoading',
  'plugins.TransponderChannelData.labels.statusEmpty',
  'plugins.TransponderChannelData.labels.statusNoMatch',
  'plugins.TransponderChannelData.labels.statusError',
  'plugins.TransponderChannelData.attribution',
  'plugins.VideoDirectorPlugin.title',
  'plugins.VideoDirectorPlugin.bottomIconLabel',
  'plugins.VideoDirectorPlugin.labels.updateSettings',
  'plugins.VideoDirectorPlugin.labels.cameraMovements',
  'plugins.VideoDirectorPlugin.labels.rotateSpeed',
  'plugins.VideoDirectorPlugin.labels.rotateLeft',
  'plugins.VideoDirectorPlugin.labels.rotateRight',
  'plugins.VideoDirectorPlugin.labels.rotateUp',
  'plugins.VideoDirectorPlugin.labels.rotateDown',
  'plugins.VideoDirectorPlugin.labels.panSpeed',
  'plugins.VideoDirectorPlugin.labels.panLeft',
  'plugins.VideoDirectorPlugin.labels.panRight',
  'plugins.VideoDirectorPlugin.labels.panUp',
  'plugins.VideoDirectorPlugin.labels.panDown',
  'plugins.VideoDirectorPlugin.labels.zoomSpeed',
  'plugins.VideoDirectorPlugin.labels.zoomIn',
  'plugins.VideoDirectorPlugin.labels.zoomOut',
  'plugins.VideoDirectorPlugin.labels.disableSelectedDot',
  'plugins.VideoDirectorPlugin.labels.rotate',
  'plugins.VideoDirectorPlugin.labels.pan',
  'plugins.VideoDirectorPlugin.labels.zoom',
  'plugins.VideoDirectorPlugin.labels.scene',
  'plugins.VideoDirectorPlugin.labels.blackEarth',
  'plugins.VideoDirectorPlugin.labels.milkyWay',
  'plugins.VideoDirectorPlugin.labels.startAutoRotate',
  'plugins.VideoDirectorPlugin.labels.stopAutoRotate',
  'plugins.VideoDirectorPlugin.help.overview',
  'plugins.VideoDirectorPlugin.help.imgAlt',
  'plugins.VideoDirectorPlugin.help.imgCaption',
  'plugins.VideoDirectorPlugin.help.howToUse',
  'plugins.VideoDirectorPlugin.help.tip1',
  'plugins.VideoDirectorPlugin.help.tip2',
  'plugins.ViewInfoRmbPlugin.rmbMenu.title',
  'plugins.ViewInfoRmbPlugin.rmbMenu.earthInfo',
  'plugins.ViewInfoRmbPlugin.rmbMenu.sensorInfo',
  'plugins.ViewInfoRmbPlugin.rmbMenu.launchSiteInfo',
  'plugins.ViewInfoRmbPlugin.rmbMenu.relatedSatellites',
  'plugins.ViewInfoRmbPlugin.errorMsgs.launchSiteNotFound',
  'plugins.ViewInfoRmbPlugin.errorMsgs.noRelatedSats',
  'plugins.ViewInfoRmbPlugin.errorMsgs.sensorNotFound',
  'plugins.WatchlistPlugin.bottomIconLabel',
  'plugins.WatchlistPlugin.title',
  'plugins.WatchlistPlugin.help.overview',
  'plugins.WatchlistPlugin.help.imgAlt',
  'plugins.WatchlistPlugin.help.imgCaption',
  'plugins.WatchlistPlugin.help.managingHeading',
  'plugins.WatchlistPlugin.help.managing',
  'plugins.WatchlistPlugin.help.howToUse',
  'plugins.WatchlistPlugin.help.tip1',
  'plugins.WatchlistPlugin.help.tip2',
  'plugins.WatchlistPlugin.help.tip3',
  'plugins.WatchlistPlugin.help.shortcutToggle',
  'plugins.WatchlistPlugin.labels.newSatellites',
  'plugins.WatchlistPlugin.labels.saveList',
  'plugins.WatchlistPlugin.labels.loadList',
  'plugins.WatchlistPlugin.labels.clearList',
  'plugins.WatchlistPlugin.labels.hideOtherObjects',
  'plugins.WatchlistPlugin.labels.labelAlways',
  'plugins.WatchlistPlugin.labels.labelFovOnly',
  'plugins.WatchlistPlugin.labels.labelOff',
  'plugins.WatchlistPlugin.labels.satellitesHeader',
  'plugins.WatchlistPlugin.labels.actionsHeader',
  'plugins.WatchlistPlugin.labels.displayHeader',
  'plugins.WatchlistPlugin.labels.labelsHeader',
  'plugins.WatchlistPlugin.msgs.watchlistLoaded',
  'plugins.WatchlistPlugin.errorMsgs.NoradAlreadyInList',
  'plugins.WatchlistPlugin.errorMsgs.ObjectAlreadyInList',
  'plugins.WatchlistPlugin.errorMsgs.SatNotFound',
  'plugins.WatchlistPlugin.settings.satLabelMode.label',
  'plugins.WatchlistPlugin.settings.satLabelMode.helpText',
  'plugins.WatchlistPlugin.settings.satLabelMode.options.off',
  'plugins.WatchlistPlugin.settings.satLabelMode.options.fovOnly',
  'plugins.WatchlistPlugin.settings.satLabelMode.options.all',
  'plugins.WatchlistPlugin.rmbMenu.addToWatchlist',
  'plugins.WatchlistPlugin.rmbMenu.removeFromWatchlist',
  'plugins.WatchlistFilter.bottomIconLabel',
  'plugins.WatchlistFilter.errorMsgs.noSatellitesInList',
  'pluginDrawer.modeCatalog',
  'pluginDrawer.modeSensors',
  'pluginDrawer.modeEvents',
  'pluginDrawer.modeCreate',
  'pluginDrawer.modeAnalysis',
  'pluginDrawer.modeConjunctions',
  'pluginDrawer.modeDisplay',
  'pluginDrawer.modeTools',
  'pluginDrawer.modeSettings',
  'pluginDrawer.modeExperimental',
  'pluginDrawer.modeRecent',
  'pluginDrawer.groupCameraModes',
  'pluginDrawer.groupLayerToggles',
  'pluginDrawer.groupSettingsToggles',
  'pluginDrawer.groupDevTools',
  'pluginDrawer.groupAbout',
  'rightClickMenu.pauseClock',
  'rightClickMenu.resetCamera',
  'rightClickMenu.clearLines',
  'rightClickMenu.clearScreen',
  'urlManager.satNotFound',
  'urlManager.intldesNotFound',
  'urlManager.deepSpaceNoEphemeris',
  'filterMenu.operationalPayloads.name',
  'filterMenu.operationalPayloads.category',
  'filterMenu.operationalPayloads.tooltip',
  'filterMenu.nonOperationalPayloads.name',
  'filterMenu.nonOperationalPayloads.category',
  'filterMenu.nonOperationalPayloads.tooltip',
  'filterMenu.rocketBodies.name',
  'filterMenu.rocketBodies.category',
  'filterMenu.rocketBodies.tooltip',
  'filterMenu.debris.name',
  'filterMenu.debris.category',
  'filterMenu.debris.tooltip',
  'filterMenu.unknownType.name',
  'filterMenu.unknownType.category',
  'filterMenu.unknownType.tooltip',
  'filterMenu.notionalSatellites.name',
  'filterMenu.notionalSatellites.category',
  'filterMenu.notionalSatellites.tooltip',
  'filterMenu.groundSensors.name',
  'filterMenu.groundSensors.category',
  'filterMenu.groundSensors.tooltip',
  'filterMenu.launchFacilities.name',
  'filterMenu.launchFacilities.category',
  'filterMenu.launchFacilities.tooltip',
  'filterMenu.vleoSatellites.name',
  'filterMenu.vleoSatellites.category',
  'filterMenu.vleoSatellites.tooltip',
  'filterMenu.leoSatellites.name',
  'filterMenu.leoSatellites.category',
  'filterMenu.leoSatellites.tooltip',
  'filterMenu.heoSatellites.name',
  'filterMenu.heoSatellites.category',
  'filterMenu.heoSatellites.tooltip',
  'filterMenu.meoSatellites.name',
  'filterMenu.meoSatellites.category',
  'filterMenu.meoSatellites.tooltip',
  'filterMenu.geoSatellites.name',
  'filterMenu.geoSatellites.category',
  'filterMenu.geoSatellites.tooltip',
  'filterMenu.xgeoSatellites.name',
  'filterMenu.xgeoSatellites.category',
  'filterMenu.xgeoSatellites.tooltip',
  'filterMenu.source.category',
  'filterMenu.vimpelSatellites.name',
  'filterMenu.vimpelSatellites.tooltip',
  'filterMenu.celestrakSatellites.name',
  'filterMenu.celestrakSatellites.tooltip',
  'filterMenu.celestrakSupSatellites.name',
  'filterMenu.celestrakSupSatellites.tooltip',
  'filterMenu.satnogsSatellites.name',
  'filterMenu.satnogsSatellites.tooltip',
  'filterMenu.countries.category',
  'filterMenu.countries.unitedStates.name',
  'filterMenu.countries.unitedStates.tooltip',
  'filterMenu.countries.unitedKingdom.name',
  'filterMenu.countries.unitedKingdom.tooltip',
  'filterMenu.countries.france.name',
  'filterMenu.countries.france.tooltip',
  'filterMenu.countries.germany.name',
  'filterMenu.countries.germany.tooltip',
  'filterMenu.countries.japan.name',
  'filterMenu.countries.japan.tooltip',
  'filterMenu.countries.china.name',
  'filterMenu.countries.china.tooltip',
  'filterMenu.countries.india.name',
  'filterMenu.countries.india.tooltip',
  'filterMenu.countries.russia.name',
  'filterMenu.countries.russia.tooltip',
  'filterMenu.countries.ussr.name',
  'filterMenu.countries.ussr.tooltip',
  'filterMenu.countries.southKorea.name',
  'filterMenu.countries.southKorea.tooltip',
  'filterMenu.countries.australia.name',
  'filterMenu.countries.australia.tooltip',
  'filterMenu.countries.otherCountries.name',
  'filterMenu.countries.otherCountries.tooltip',
  'filterMenu.miscellaneous.category',
  'filterMenu.miscellaneous.starlinkSatellites.name',
  'filterMenu.miscellaneous.starlinkSatellites.tooltip',
  'satInfoBox.title',
  'satInfoBox.Cospar.label',
  'satInfoBox.Cospar.tooltip',
  'satInfoBox.Norad.label',
  'satInfoBox.Norad.tooltip',
  'satInfoBox.AltName.label',
  'satInfoBox.AltName.tooltip',
  'satInfoBox.AltId.label',
  'satInfoBox.AltId.tooltip',
  'satInfoBox.Source.label',
  'satInfoBox.Source.tooltip',
  'satInfoBox.Confidence.label',
  'satInfoBox.Confidence.tooltip',
  'satInfoBox.Confidence.high',
  'satInfoBox.Confidence.medium',
  'satInfoBox.Confidence.low',
  'satInfoBox.Confidence.external',
  'satInfoBox.notAvailable',
  'satInfoBox.oemFile',
  'satInfoBox.copy.copied',
  'satInfoBox.copy.tooltip',
  'SatInfoBoxObject.title',
  'SatInfoBoxObject.Type.label',
  'SatInfoBoxObject.Type.tooltip',
  'SatInfoBoxObject.Type.unknown',
  'SatInfoBoxObject.Type.payload',
  'SatInfoBoxObject.Type.rocketBody',
  'SatInfoBoxObject.Type.debris',
  'SatInfoBoxObject.Type.special',
  'SatInfoBoxObject.Type.missile',
  'SatInfoBoxObject.Status.label',
  'SatInfoBoxObject.Status.tooltip',
  'SatInfoBoxObject.Status.operational',
  'SatInfoBoxObject.Status.nonOperational',
  'SatInfoBoxObject.Status.partiallyOperational',
  'SatInfoBoxObject.Status.extendedMission',
  'SatInfoBoxObject.Status.backupStandby',
  'SatInfoBoxObject.Status.spare',
  'SatInfoBoxObject.Status.unknown',
  'SatInfoBoxObject.Country.label',
  'SatInfoBoxObject.Country.tooltip',
  'SatInfoBoxObject.LaunchSite.label',
  'SatInfoBoxObject.LaunchSite.tooltip',
  'SatInfoBoxObject.LaunchVehicle.label',
  'SatInfoBoxObject.LaunchVehicle.tooltip',
  'SatInfoBoxObject.Configuration.label',
  'SatInfoBoxObject.Configuration.tooltip',
  'SatInfoBoxObject.RCS.label',
  'SatInfoBoxObject.RCS.tooltip',
  'SatInfoBoxObject.StdMag.label',
  'SatInfoBoxObject.StdMag.tooltip',
  'SatInfoBoxObject.AppMag.label',
  'SatInfoBoxObject.AppMag.tooltip',
  'SatInfoBoxObject.estimatedSuffix',
  'SatInfoBoxObject.unknown',
  'SatInfoBoxManeuver.noEventDetected',
  'SatInfoBoxManeuver.orbitOutOfFamily',
  'SatInfoBoxManeuver.stabilityChange',
  'SatInfoBoxOrbital.title',
  'SatInfoBoxOrbital.Apogee.label',
  'SatInfoBoxOrbital.Apogee.tooltip',
  'SatInfoBoxOrbital.Perigee.label',
  'SatInfoBoxOrbital.Perigee.tooltip',
  'SatInfoBoxOrbital.Inclination.label',
  'SatInfoBoxOrbital.Inclination.tooltip',
  'SatInfoBoxOrbital.Eccentricity.label',
  'SatInfoBoxOrbital.Eccentricity.tooltip',
  'SatInfoBoxOrbital.RightAsc.label',
  'SatInfoBoxOrbital.RightAsc.tooltip',
  'SatInfoBoxOrbital.ArgOfPerigee.label',
  'SatInfoBoxOrbital.ArgOfPerigee.tooltip',
  'SatInfoBoxOrbital.Latitude.label',
  'SatInfoBoxOrbital.Latitude.tooltip',
  'SatInfoBoxOrbital.Latitude.north',
  'SatInfoBoxOrbital.Latitude.south',
  'SatInfoBoxOrbital.Longitude.label',
  'SatInfoBoxOrbital.Longitude.tooltip',
  'SatInfoBoxOrbital.Longitude.east',
  'SatInfoBoxOrbital.Longitude.west',
  'SatInfoBoxOrbital.Altitude.label',
  'SatInfoBoxOrbital.Altitude.tooltip',
  'SatInfoBoxOrbital.Period.label',
  'SatInfoBoxOrbital.Period.tooltip',
  'SatInfoBoxOrbital.Period.meanMotion',
  'SatInfoBoxOrbital.Period.revPerDay',
  'SatInfoBoxOrbital.Period.min',
  'SatInfoBoxOrbital.Velocity.label',
  'SatInfoBoxOrbital.Velocity.tooltip',
  'SatInfoBoxOrbital.AgeOfGP.label',
  'SatInfoBoxOrbital.AgeOfGP.tooltip',
  'SatInfoBoxOrbital.AgeOfGP.days',
  'SatInfoBoxOrbital.AgeOfGP.hours',
  'SatInfoBoxOrbital.AgeOfGP.epochYear',
  'SatInfoBoxOrbital.AgeOfGP.epochDay',
  'SatInfoBoxOrbital.RadialSigma.label',
  'SatInfoBoxOrbital.RadialSigma.tooltip',
  'SatInfoBoxOrbital.InTrackSigma.label',
  'SatInfoBoxOrbital.InTrackSigma.tooltip',
  'SatInfoBoxOrbital.CrossTrackSigma.label',
  'SatInfoBoxOrbital.CrossTrackSigma.tooltip',
  'SatInfoBoxOrbital.meter',
  'SatInfoBoxOrbital.kilometer',
  'SatInfoBoxOrbital.second',
  'SatInfoBoxOrbital.unknown',
  'ScreenRecorder.recordingUnavailable',
  'ScreenRecorder.compatibilityError',
  'SelectSatManager.objectInsideEarth',
  'SelectSatManager.secondaryObjectSet',
  'TopMenu.showHelp',
  'TopMenu.toggleFullscreen',
  'TopMenu.searchPlaceholder',
  'VcrPlugin.scenarioEnded',
  'VcrPlugin.clickToPlay',
  'VcrPlugin.clickToPause',
  'VcrPlugin.clickToResume',
  'VcrPlugin.endOfScenario',
] as const;

const translationCache: Map<TranslationKey, string> = new Map();

// Type for all valid translation keys
export type TranslationKey = typeof Keys[number];

/**
 * Translates a given key into the corresponding localized string.
 * The name t7e represents t + 7 + e, where 7 is the number of letters in the word "translate".
 *
 * @param key - The translation key to be localized. This should correspond to a valid key in the translation files.
 * @param options - An optional object containing variables to interpolate into the localized string.
 * @returns The localized string corresponding to the provided key. If no localization is found, the key itself is returned.
 *
 * @remarks
 * This function is a placeholder and should be replaced with the actual `t7e` integration
 * or another localization library implementation.
 */
export function t7e(key: TranslationKey, options?: Record<string, any>): string {
  // Check if the translation is already cached
  if (translationCache.has(key)) {
    return translationCache.get(key)!;
  }

  // Perform the translation using i18next
  const translatedString = i18next.t(key, options) as string;

  // Cache the translation
  translationCache.set(key, translatedString);

  return translatedString;
}
